
import BasicLayout from '../module/layouts/BasicLayout';
import UserLayout from '../module/layouts/UserLayout';
import BaseHeadLayout from "../module/layouts/BaseHeadLayout";
import { P404, P403, P500 } from '../module/index';

import {
  Version,
  VersionDetail
} from '@/containers/version'

import {
  OrgNodeCategory,
  Organization,
  PositionManager,
  PositionDetail,
  PositionCategoryManager,
  PersonInfoDetail,
  OrganizationFileImport,
  OrgAuthorityManagement,
  PersonManage,
  PersonDetail,
  DealerManager,
  DealerInfoDetail,
  DealerDetail,
  DealerUnionManager,
  AdministrationScope,
  DealerUnionFileImport,
  AbilityAssess,
  ImportTemporary,
  OrganizationZoneCode,
  OrganizationZoneCodeDetail,
  PersonFaceAuthDetail,
  ImportSchoolCooperationPerson,
  ImportPerson,
  ManagerPermissionsSettingManager
} from '@/containers/org';
import {
  ElementsList,
  RoleList,
  RoleUserList,
  RoleGroupList,
  ApiInfoList,
  UserList,
  GroupList,
  GroupUserList,
  MenuList,
  MenuDetail,
  MenuPower,
  RoleManager,
  RoleSetsList,
  AuthUserLog,
  ThirdCopr,
  ThirdApp,
  ThirdCorpUser,
  ThirdAppAuthSetting
} from '@/containers/auth';
import {
  MessageTask,
  MessageTaskDetail,
  NoticeRecord,
  NoticeRecordDetail,
} from '@/containers/message';

import {
  QuestionType,
  SeriesProgram,
  TypeAuth,
  SurveyManager,
  SurveyDetail,
  SurveyPreview,
  SurveyTemplateManager,
  SurveyTemplateDetail,
  SurveyRecordInfo,
  SurveyRecordInfoDetail,
  SurveyTemplatePreview,
  QuestionTypeFileImport,
  Comment,
  OperateRecord,
  Featured,
  FeaturedDetail,
  FeaturedLook,
  InviteLetterManager,
  InviteLetterEdit,
  LabelManager,LabelDetail,LabelView,LabelUser,LabelUserLook,LabelUserImport,LabelFeatureContent
} from '@/containers/biz';

import Login from '@/containers/login';
import {ThirdLogin,IdaasHome} from '@/containers/thirdLogin';
import WhiteList from '@/containers/whitelist';

import {
  ProgramDetail,
  ProgramList,
  ProgramDetailShow,
  ProgramEvaluation,
  Exam,
  ExamDetail,
  ExamInfo,
  ExamAuth,
  ExamTempGroupManage,
  ExamLook,
  ExamChapter,
  ExamTemplate,
  ExamTemplateDetail,
  ExamTemplateChapter,
  ExamTemplateLook,
  ExamTemplateGroup,
  ExamTemplateGroupDetail,
  ExamTemplateGroupInfo,
  ExamRecordManager,
  ExamGradeInfo,
  ExamRecordInfo,
  ScheduleList,
  ScheduleDetail,
  LiveBroadcastList,
  BankQuestion,
  BankQuestionDetail,
  BankQuestionImport,
  LiveDetail,
  ProgramAuth,
  LiveAuth,
  SeriesProgramList,
  SeriesDetail,
  SeriesInfo,
  SeriesContentList,
  SeriesContentDetail,
  LiveList,
  HostList,
  AssessmentRulesList,
  LiveRecordList,
  NormalDealerList,
  LiveStatisticsList,
  LiveInfo,
  DealerRuleImport,
  CoursewareList,
  LookCourseware,
  HostLiveRecordList,
  SeriesFileImport,
  ErrorQuestionInfoList,
  ErrorQuestionAnalysisList,
  ErrorQuestionPersonInfoList,
  SubjectiveReview,
  ExaminationRecord,
  ExaminationReview,
  ExaminationLook,
  InteractLiveResources,
  ResourcesLiveList,
  ExamPersonAuthManager,
  ExamPersonAuthDetail,
  LearningRecordManager,
  PracticeManager,
  PracticeDetail,
  PracticeView,
  PracticeRankInfo,
  PracticeRankDate,
  PracticeRecord,
  PracticePaperInfo
} from '@/containers/online';

import {
  OfflineProgramList,
  OfflineProgramDetail,
  ClassList,
  ClassAnnouncement,
  ClassAlbum,
  ClassDetail,
  ClassAideDetail,
  ClassStudentDetail,
  ClassStudentList,
  ClassStudentQrList,
  SignInList,
  ClassResult,
  ClassResultFileImport,
  ClassStudentExamList,
  ClassStudentSurveyList,
  Classroom,
  ClassroomDetail,
  RemoteAuthList,
  RemoteAuthFileImport,
  RemoteAuthScoreFileImport,
  StudentRemoteAuthDetailList,
  OrgRemoteEvaluationDetailList,
  OrgRemoteEvaluationDetail,
  OrgRemoteEvaluationDetailInfo,
  StudentRemoteAuthScore,
  ClassStudentHomeworkList,
  ClassStudentInteractLiveList,
  ClassStudentRemoteAuthList,
  ClassStudentNEVRemoteAuthList,
  ClassStudentProgramList,
  ClassStudentContentList,
  LookClassInfo,
  RemoteAuthDetail,
  StudentRemoteAuthScoreImport,
  OrgRemoteEvaluationScoreImport,
  OrgRemoteEvaluationScore,
  OrgRemoteEvaluationInteractLiveList,
  TrainSiteLook,
  NevRemoteAuthDetailList,
  LectureNevAuthDetailList,
  NevRemoteAuthScore,
  CompetencyCertificationModel
} from '@/containers/face';

import {
  UserManagement,
  Dynamic,
  RecordLog,
  TemplateDemo,
  Template,
  TableList,
  ListSelect,
  FormRender,
  AddSection,
  ShowSubject,
  BrowserExport,
  Upload,
  Charts,
  Steps,
  Anchor,
  ExamPreview,
  QuestionPreview,
  QuestionResult,
  TreeSelectList,
  Questionnair,
  ExamPercent,
  FormLinks,
  Iframe,
  DataAuthSelect,
  OssUpload,
  Cropper,
  WizLocationSelectDemo,
  WizCalendarDemo,
  WizAuthorityDemo,
  PositionRadarDemo,
  EditeorDemo,
  Copy,
  Image,
  StuTabs,
  TableToExcel,
  HighSetDemo
} from '../containers/demo'

import {
  AbilityCheckCategoryList,
  AbilityCheckCategoryDetail,
  AbilityCheckItemList,
  StudentAbilityList,
  AbilityCheckItemDetail,
  StudentAbilityItemDetail,
  StudentAbilityFileImport,
  TrainPathList,
  trainPathStageScoreRule,
  trainPathStageScoreRuleDetail,
  TrainPathDetail,
  TrainPathCommentList,
  TrainPathCommentDetail,
  LookComment,
  TrainPathStage,
  LookTrainPath,
  StudentTrainPathList,
  CertDetail,
  CertList,
  CertInfo,
  PersonalCertList,
  PersonalCertInfo,
  CertApplyAuditDetail,
  CertApplyList,
  PersonalCertIDetail,
  CertLinkList,
  CertImport,
  CertLinkImport,
  SubjectList,
  SubjectDetail,
  SubjectInfo,
  SubjectCreditRecordList,
  StudentCommentAudit,
  AuditComment,
  RequirementList,
  RequirementDetail,
  RequirementRecord,
  TrainPathFileImport,
  CertificateStatistics,
  CertificateStatisticsCfg,
  CertStageList,
  RequirementPersonnelList,
  RequirementPersonnelDetailList,
  RequirementPersonnelApplyList,
  RequirementConfigList,
  RequirementConfigDetail,
  DealerNewPersonTrainList,
  DealerNewPersonTrainDetailList,
  RequirementPartTimePosition,
  RequirementPartTimePositionDetail,
} from '../containers/train'

import {
  ModelList,
  ProcdefList,
  WorkflowAuditDetail,
  WorkflowAudit,
  ProcinsRun,
  ProcinsEnd,
  ProcTaskTodo,
  ProcTaskDone,
  AuditDetail,
  AuditHistory,
  Apply,
  ApplySteps,
  ApplyManager,
  ApplyInfo,
  ApplyVerify,
  ApplyVerifyList,
  ApplyPlanNormal,
  ApplyPlanClass,
  StudentGradesFileImport
} from '@/containers/workflow';

import {
  ApplicationColumnManager,
  ApplicationManageInfo,
  ApplicationManageLook,
  ApplicationManageDetail,
  ApplicationColumnDetail,
  ApplicationColumnLook,
  ApplicationColumnRecord
} from '@/containers/application'

import {
  Topic,
  TopicDetail,
  TopicLook,
  InvitationManager,
  InvitationDetail,
  InvitationLook,
  ActivityManager,
  ActivityDetail,
  ActivityLook,
  ActivityTopic,
  ActivityPartManager,
  ActivityPartDetail,
  ActivityPartLook,
  ActivityMessageManager,
  ActivityMessageDetail,
  TopicFollow,
  ShortVideoManager,
  ShortVideoLook,
  ShortVideoDetail,
  ShortVideoRecord,
  ShortVideoScreenManager,
  ShortVideoScreenRecordManager,
  ShortVideoScreenToDeal,
  ShortVideoPersonRelationManager,
  ShortVideoMessageManager
} from '@/containers/interact'
import {
  ContentManage,
  ContentDetail,
  ContentView,
  ContentPreview,
  ContentLabel,
  ContentRecord,
  TaskInfo,
  TaskRecord,
  TaskEdit,
  TaskNotice,
} from '@/containers/content'

import Home from '@/containers/home'
import {
  RuleConfigure,
  RuleConfigureDetail,
  RuleLook
} from '@/containers/rules'

import Video from '@/containers/video'

import SubjectForm from '../containers/exam/subject/form'

import RemoteAuth from '@/containers/remoteAuth'

import RemoteAssessment from '@/containers/remoteAssessment'

import { TrainReport, TableConfigList, TableFieldList, TableFieldDetail, ReportConfigList, ReportConfigDetailList, ReportConfigForm } from '@/containers/dataReport'

import AudienceGroup from '@/containers/audience/group';
import AudienceGroupDetail from '@/containers/audience/group/detail';
import AudienceGroupPriview from '@/containers/audience/group/preview';

import {
  HomeworkList,
  HomeworkDetail,
  HomeworkInfo,
  HomeworkRecordList,
  HomeworkRecordReviewList,
  HomeworkRecordShow,
  HomeworkRecordAudit
} from '@/containers/internalTrain'
import commonConfigManager from '../containers/common/commonConfig/commonConfig';
import commonConfigDetail from '../containers/common/commonConfig/commonConfigEdit/commonConfigDetail';

import ExamScoreStatistics from '@/containers/reportStatistics/examRecordStatistics/examScoreStatistics'
import OrgExaminationStatistics from '@/containers/reportStatistics/examRecordStatistics/orgExaminationStatistics'
import OrgJobExaminationStatistics from '@/containers/reportStatistics/examRecordStatistics/orgJobExaminationStatistics'
import ExamEverydayStatistics from '@/containers/reportStatistics/examRecordStatistics/examEverydayStatistics'
import ExamEverydayRecordStatistics from '@/containers/reportStatistics/examRecordStatistics/examEverydayRecordStatistics'
import OnlineCourseCompletionStatus from '@/containers/reportStatistics/onlineCourseStatistics/onlineCourseCompletionStatus'
import OrgCourseLearningStatistics from '@/containers/reportStatistics/onlineCourseStatistics/orgCourseLearningStatistics'
import CourseLearningStatistics from '@/containers/reportStatistics/onlineCourseStatistics/courseLearningStatistics'
import OfflineTrainingAndCertificationStatistics from '@/containers/reportStatistics/offlineTrainingStatistics/offlineTrainingAndCertificationStatistics'
import OrgStatisticsOfflineTrainingAndLearning from '@/containers/reportStatistics/offlineTrainingStatistics/orgStatisticsOfflineTrainingAndLearning'
import StatisticsOfflineTrainees from '@/containers/reportStatistics/offlineTrainingStatistics/statisticsOfflineTrainees'
import StatisticsOfflineTrainingAndLearning from '@/containers/reportStatistics/offlineTrainingStatistics/statisticsOfflineTrainingAndLearning'
import OrgCertificationStatistics from '@/containers/reportStatistics/certificationStatistics/orgCertificationStatistics'
import PersonnelCertificateAcquisitionDetails from '@/containers/reportStatistics/certificationStatistics/personnelCertificateAcquisitionDetails'
import OrgPathCompletion from '@/containers/reportStatistics/pathReport/orgPathCompletion'
import OrgPathCompletionInfo from "@/containers/reportStatistics/pathReport/orgPathCompletionInfo";
import PersonalPathCompletion from '@/containers/reportStatistics/pathReport/personalPathCompletion';
import PersonalPathCompletionRate from "@/containers/reportStatistics/pathReport/personalPathCompletionRate";
import PersonalPathTaskDetails from '@/containers/reportStatistics/pathReport/personalPathTaskDetails'
import PersonalPathTaskCompletion  from "@/containers/reportStatistics/pathReport/personalPathTaskCompletion";
import PersonalPathScoreCompletion  from "@/containers/reportStatistics/pathReport/personalPathScoreCompletion";
import DimStudentReport  from "@/containers/reportStatistics/dimStudentReport";

import TrainingStatisticsManagement from '@/containers/trainingStatistics/trainingStatisticsManagement'
import TrainingStatisticsDetail from '@/containers/trainingStatistics/trainingStatisticsDetail'

import {
  PermissionsManager,
  PermissionsAdd,
} from '@/containers/permissions'

import {
  CleExamManager,
  CleExamDetail,
} from '@/containers/cle'

import {
  PermissionSettingManager,
  PermissionSettingAdd,
} from '@/containers/permissionSetting'


import {
  SyncRelationPositionManager,
  PositionChangeRecordManager,
  SyncTimsTransfer
} from '@/containers/data'

import {
  SyncEmailConfigManager
} from '@/containers/syncEmailConfig'

// 水印
import {
  WatermarkManager,
  WatermarkDetail
} from '@/containers/watermark'

import {
  PDFPreview,
} from '@/containers/preview'


import {
  AccountConsolidationRecordManager,
  AccountConsolidationRecordDetail,
  AccountConsolidationRecordAdd,
} from '@/containers/accountConsolidationRecord'

/**
 * 主路由配置
 *
 * path 路由地址
 * component 组件
 * indexRoute 默认显示路由
 * childRoutes 所有子路由
 * NotFound 路由要放到最下面，当所有路由当没匹配到时会进入这个页面
 */

const _routesConfig = [
  {
    path: '/sign',
    title: '登录',
    indexRoute: '/sign/login',
    component: UserLayout,
    childRoutes: [
      //登录
      { key: 'Login', title: '登录', path: '/sign/login', component: Login },
      { key: '404', title: '页面没有找到', path: '', component: P404 }
    ]
  },
  {
    path: '/remote',  // 用于客户端远程认证考卷
    title: '客户端远程认证列表',
    indexRoute: '/remote/list',
    component: UserLayout,
    childRoutes: [
      { key: 'remotec', title: '远程认证客户端考卷', path: '/remote/list', component: RemoteAuth },

      { key: '404', title: '页面没有找到', path: '', component: P404 }
    ]
  },
  {
    path: '/remoteAssessment',  // 用于客户端远程认证考卷
    title: '客户端远程评估列表',
    indexRoute: '/remoteAssessment/list',
    component: UserLayout,
    childRoutes: [
      { key: 'remoteAssessment', title: '远程评估客户端考卷', path: '/remoteAssessment/list', component: RemoteAssessment },
      { key: '404', title: '页面没有找到', path: '', component: P404 }
    ]
  },
  {
    path: '/video',  // 用于客户端远程评估视频播放
    title: '视频播放',
    indexRoute: '/video/play',
    component: UserLayout,
    childRoutes: [
      { key: 'video', title: '录像', path: '/video/play', component: Video },

      { key: '404', title: '页面没有找到', path: '', component: P404 }
    ]
  },
  {
    path: '/homeworkRecord',
    title: '作业记录信息',
    indexRoute: '/homeworkRecord/homeworkRecordShow',
    component: BaseHeadLayout,
    childRoutes: [
      { key: 'homeworkRecordShow', title: '查看作业记录信息', path: '/homeworkRecord/homeworkRecordShow', component: HomeworkRecordShow },
      { key: 'homeworkRecordAudit', title: '批改作业', path: '/homeworkRecord/homeworkRecordAudit', component: HomeworkRecordAudit },
      { key: '404', title: '页面没有找到', path: '', component: P404 }
    ]
  },
  {
    path: '/subjectiveReview',
    title: '主观题批阅',
    indexRoute: '/subjectiveReview/review',
    component: BaseHeadLayout,
    childRoutes: [
      { key: 'examinationReview', title: '批阅', path: '/subjectiveReview/review', component: ExaminationReview },
      { key: 'examinationReviewLook', title: '查看', path: '/subjectiveReview/look', component: ExaminationLook},
      { key: '404', title: '页面没有找到', path: '', component: P404 }
    ]
  },
  {
    path: '/mobile',  //app支持页面
    title: 'CYC移动课堂',
    indexRoute: '/mobile',
    component: UserLayout,
    childRoutes: [
      { key: 'mobileExamDetail', title: '考试预览', path: '/mobile/examInfo', component: ExamInfo },
      { key: 'Login', title: '登录', path: '/mobile/login', component: ThirdLogin },
      { key: 'IdaasHome', title: '首页', path: '/mobile/home', component: IdaasHome },
      { key: '404', title: '页面没有找到', path: '', component: P404 }
    ]
  },
  {
    path: '/preview',  // 用于预览文件
    title: '预览',
    indexRoute: '/preview/404',
    component: UserLayout,
    childRoutes: [
      { key: 'pdf', title: '录像', path: '/preview/pdf', component: PDFPreview },
      { key: '404', title: '页面没有找到', path: '', component: P404 }
    ]
  },
  {
    path: '/',
    title: '首页',
    component: BasicLayout,
    indexRoute: '/home',
    childRoutes: [
      //首页
      { key: 'home', title: '首页', path: '/home', component: Home },

      //用户记录日志
      { key: 'AuthUserLog', title: '用户记录日志', path: '/auth/authUserLog', component: AuthUserLog },

      //公共配置管理
      { key: 'commonConfigDetail', title: '公共配置修改', path: '/common/commonConfig/commonConfigUpd', component: commonConfigDetail ,cached: true },
      { key: 'commonConfigDetail', title: '公共配置新增', path: '/common/commonConfig/commonConfigAdd', component: commonConfigDetail ,cached: true },
      { key: 'commonConfig', title: '公共配置管理', path: '/common/commonConfig', component: commonConfigManager },

      //版本管理
      { key: 'versionUpd', title: '编辑版本', path: '/version/management/versionUpd', component: VersionDetail, },
      { key: 'versionAdd', title: '新增版本', path: '/version/management/versionAdd', component: VersionDetail, },
      { key: 'version', title: '版本管理', path: '/version/management', component: Version },

      //组织管理
      { key: 'OrganizationFileImport', title: '组织信息批量导入', path: '/org/organization/fileImport', component: OrganizationFileImport, },
      { key: 'OrgAuthorityManagement', title: '组织权限管理', path: '/org/organization/orgAuthorityManagement', component: OrgAuthorityManagement },
      { key: 'Organization', title: '组织结构管理', path: '/org/organization', component: Organization },
      { key: 'OrgNodeCategory', title: '组织类型管理', path: '/org/orgNodeCategory', component: OrgNodeCategory },
      { key: 'OrganizationZoneCode', title: 'zoneCode管理',path: '/org/zoneCode', component: OrganizationZoneCode},
      { key: 'OrganizationZoneCodeDetail', title: 'zoneCode管理新增',path: '/org/zoneCode/zoneCodeAdd', component: OrganizationZoneCodeDetail},
      { key: 'OrganizationZoneCodeDetail', title: 'zoneCode管理编辑',path: '/org/zoneCode/zoneCodeUpd', component: OrganizationZoneCodeDetail},

      { key: 'userManagement', title: '用户管理原始demo', path: '/org/userManagement', component: UserManagement },
      { key: 'RoleUserList', title: '角色人员维护', path: '/auth/roleList/roleUserList', component: RoleUserList },
      { key: 'RoleGroupList', title: '角色用户组管理', path: '/auth/roleList/roleGroupList', component: RoleGroupList },
      { key: 'RoleManager', title: '权限管理', path: '/auth/roleList/roleManager', component: RoleManager },
      { key: 'RoleList', title: '角色管理', path: '/auth/roleList', component: RoleList },
      { key: 'UserList', title: '用户管理', path: '/auth/userList', component: UserList },
      { key: 'GroupUserList', title: '用户组人员管理', path: '/auth/group/groupUser', component: GroupUserList },
      { key: 'GroupList', title: '用户组管理', path: '/auth/group', component: GroupList },

      { key: 'positionDetail', title: '岗位管理-新增', path: '/org/position/positionDetailAdd', component: PositionDetail,cached: true },
      { key: 'positionDetail', title: '岗位管理-编辑', path: '/org/position/positionDetailUpd', component: PositionDetail,cached: true },
      { key: 'position', title: '岗位管理', path: '/org/position', component: PositionManager },
      { key: 'positionCategory', title: '岗位分类管理', path: '/org/positionCategory', component: PositionCategoryManager },
      // { key: 'editPerson', title: '编辑', path: '/org/personManage/editPerson', component: AddPerson },
      // { key: 'addPerson', title: '新增', path: '/org/personManage/addPerson', component: AddPerson },
      // { key: 'administrationScope', title: '管理范围', path: '/org/personManage/administrationScope', component: AdministrationScope },
      // { key: 'personManage', title: '人员管理', path: '/org/personManage', component: PersonManage },

      { key: 'personFaceAuthDetail', title: '人脸采集信息', path: '/org/person/personFaceAuthDetail', component: PersonFaceAuthDetail },
      { key: 'PersonInfoDetail', title: '查看人员信息', path: '/org/person/personInfoDetail', component: PersonInfoDetail },
      { key: 'personDetail', title: '人员管理-新增', path: '/org/person/personDetailAdd', component: PersonDetail,cached: true },
      { key: 'personDetail', title: '人员管理-编辑', path: '/org/person/personDetailUpd', component: PersonDetail,cached: true },
      { key: 'administrationScope', title: '管理范围', path: '/org/person/administrationScope', component: AdministrationScope },
      { key: 'person', title: '人员管理', path: '/org/person', component: PersonManage },
      { key: 'personImport', title: '导入临时人员', path: '/org/person/import', component: ImportTemporary },
      { key: 'importSchoolCooperationPerson', title: '导入校企合作人员', path: '/org/person/importSchoolCooperationPerson', component: ImportSchoolCooperationPerson },
      { key: 'importPerson', title: '导入人员', path: '/org/person/importPerson', component: ImportPerson },

      { key: 'personByDealerId', title: '人员管理', path: '/org/dealer/lookPositionNumber', component: PersonManage },
      { key: 'dealerDetail', title: '经销商管理-新增', path: '/org/dealer/dealerDetailAdd', component: DealerDetail, cached: true },
      { key: 'dealerDetail', title: '经销商管理-编辑', path: '/org/dealer/dealerDetailUpd', component: DealerDetail, cached: true},
      { key: 'dealerInfoDetail', title: '查看经销商', path: '/org/dealer/dealerInfoDetail', component: DealerInfoDetail },
      { key: 'dealer', title: '经销商管理', path: '/org/dealer', component: DealerManager },

      { key: 'dealerUnionFileImport', title: '共建店导入', path: '/org/dealerUnion/dealerUnionImport', component: DealerUnionFileImport },
      { key: 'dealerUnion', title: '共建店管理', path: '/org/dealerUnion', component: DealerUnionManager },

      //权限管理
      { key: 'ElementsList', title: '元素管理', path: '/auth/elementsList', component: ElementsList },
      { key: 'ApiInfoList', title: '接口管理', path: '/auth/apiInfoList', component: ApiInfoList },
      { key: 'MenuPower', title: '权限管理', path: '/auth/menu/menuPower', component: MenuPower },
      { key: 'MenuDetail', title: '新增菜单', path: '/auth/menu/menuDetailAdd', component: MenuDetail ,cached: true},
      { key: 'MenuDetail', title: '编辑菜单', path: '/auth/menu/menuDetailUpd', component: MenuDetail, cached: true },
      { key: 'MenuList', title: '菜单管理', path: '/auth/menu', component: MenuList },
      { key: 'RoleSetsList', title: '角色组管理', path: '/auth/roleSetsList', component: RoleSetsList },
      //biz服务
      { key: 'TypeAuth', title: '权限管理', path: '/biz/categoryType/program/auth', component: TypeAuth },
      { key: 'QuestionTypeFileImportQuestion', title: '批量导入', path: '/biz/categoryType/question/fileImport', component: QuestionTypeFileImport },
      { key: 'TypeAuth', title: '权限管理', path: '/biz/categoryType/question/auth', component: TypeAuth },
      { key: 'QuestionTypeProgramFileImport', title: '批量导入', path: '/biz/categoryType/program/fileImport', component: QuestionTypeFileImport },
      { key: 'QuestionTypeExaminationFileImport', title: '批量导入', path: '/biz/categoryType/examination/fileImport', component: QuestionTypeFileImport },
      { key: 'QuestionTypeOfflineTrainFileImport', title: '批量导入', path: '/biz/categoryType/offlineTrain/fileImport', component: QuestionTypeFileImport },
      { key: 'QuestionTypeContentFileImport', title: '批量导入', path: '/biz/categoryType/content/fileImport', component: QuestionTypeFileImport },
      { key: 'QuestionTypeLabelFileImport', title: '批量导入', path: '/biz/categoryType/label/fileImport', component: QuestionTypeFileImport },
      { key: 'QuestionTypeLabelFileImport', title: '批量导入', path: '/biz/categoryType/homeworkLabel/fileImport', component: QuestionTypeFileImport },
      { key: 'questionType', title: '题目分类管理', path: '/biz/categoryType/question', component: QuestionType },
      { key: 'questionType', title: '课程分类管理', path: '/biz/categoryType/program', component: QuestionType },
      { key: 'questionType', title: '考试分类管理', path: '/biz/categoryType/examination', component: QuestionType },
      { key: 'questionType', title: '培训分类管理', path: '/biz/categoryType/offlineTrain', component: QuestionType },
      { key: 'questionType', title: '栏目应用分类管理', path: '/biz/categoryType/applicationColumn', component: QuestionType },
      { key: 'questionType', title: '系列化课程分类管理', path: '/biz/categoryType/series', component: QuestionType },
      { key: 'questionType', title: '直播分类管理', path: '/biz/categoryType/interactLive', component: QuestionType },
      { key: 'questionType', title: '学分分类管理', path: '/biz/categoryType/credit', component: QuestionType },
      { key: 'questionType', title: '内容分类管理', path: '/biz/categoryType/content', component: QuestionType },
      { key: 'questionType', title: '标签分类管理', path: '/biz/categoryType/label', component: QuestionType },
      { key: 'questionType', title: '作业分类管理', path: '/biz/categoryType/homework', component: QuestionType },
      { key: 'questionType', title: '作业标签分类管理', path: '/biz/categoryType/homeworkLabel', component: QuestionType },
      { key: 'questionType', title: '证书分类管理', path: '/biz/categoryType/cert', component: QuestionType },

      //{ key: 'seriesProgram', title: '系列化课程详情分类管理', path: '/biz/categoryType/seriesProgram', component: SeriesProgram },

      //题目管理
      { key: 'BankQuestionDetail', title: '新增题目', path: '/online/bankQuestion/bankQuestionAdd', component: BankQuestionDetail, cached: true },
      { key: 'BankQuestionDetail', title: '编辑题目', path: '/online/bankQuestion/bankQuestionUpd', component: BankQuestionDetail, cached: true },
      { key: 'BankQuestionImport', title: '题目导入', path: '/online/bankQuestion/fileImport', component: BankQuestionImport },

      { key: 'BankQuestion', title: '题目管理', path: '/online/bankQuestion', component: BankQuestion },

      //在线课程
      { key: 'LearningRecord', title: '学习记录', path: '/program/programList/learningRecord', component: LearningRecordManager },
      { key: 'ProgramDetail', title: '受众设置', path: '/program/programList/programAuth', component: ProgramAuth },
      { key: 'ProgramDetail', title: '新增课程', path: '/program/programList/programDetailAdd', component: ProgramDetail,cached: true},
      { key: 'ProgramDetail', title: '编辑课程', path: '/program/programList/programDetailUpd', component: ProgramDetail,cached: true },
      { key: 'ProgramDetailShow', title: '查看关联课程', path: '/interact/activity/activityDetailToPart/activityPartLook/toProgram', component: ProgramDetailShow },
      { key: 'ProgramDetailShow', title: '查看课程', path: '/program/programList/programDetailShow', component: ProgramDetailShow },
      { key: 'ProgramEvaluation', title: '课程评价管理', path: '/program/programList/programEvaluation', component: ProgramEvaluation },
      { key: 'ProgramList', title: '课程管理', path: '/program/programList', component: ProgramList },

      //课件
      { key: 'ScheduleDetail', title: '新增课件', path: '/program/scheduleList/scheduleDetailAdd', component: ScheduleDetail,cached: true },
      { key: 'ScheduleDetail', title: '编辑课件', path: '/program/scheduleList/scheduleDetailUpd', component: ScheduleDetail,cached: true },
      { key: 'ScheduleList', title: '课件管理', path: '/program/scheduleList', component: ScheduleList },

      //第三方课件
      { key: 'LookCourseware', title: '第三方课件查看', path: '/courseware/coursewareShow', component: LookCourseware },
      { key: 'CoursewareList', title: '第三方课件管理', path: '/courseware', component: CoursewareList },

      //考试错题率分析
      { key: 'errorQuestionPersonInfoList', title: '错误人员情况', path: '/online/examRecord/errorQuestionInfo/errorQuestionAnalysis/errorQuestionPersonInfoList', component: ErrorQuestionPersonInfoList },
      { key: 'errorQuestionAnalysis', title: '错误分析', path: '/online/examRecord/errorQuestionInfo/errorQuestionAnalysis', component: ErrorQuestionAnalysisList },
      { key: 'errorQuestionInfoList', title: '错题率分析', path: '/online/examRecord/errorQuestionInfo', component: ErrorQuestionInfoList },
      //在线考核
      { key: 'examPersonAuthLook', title: '身份验证查看', path: '/online/examRecord/examPersonAuthLook', component: ExamPersonAuthDetail },
      { key: 'examPersonAuthAudit', title: '身份验证审核', path: '/online/examRecord/examPersonAuthAudit', component: ExamPersonAuthDetail },
      { key: 'examRecordAuthAudit', title: '身份验证审核', path: '/online/examRecord/examRecordAuthAudit', component: ExamPersonAuthDetail },
      { key: 'examPersonAuthManager', title: '身份验证记录', path: '/online/examRecord/examPersonAuth', component: ExamPersonAuthManager },
      { key: 'examRecordTOPositionInfo', title: '查看任职', path: '/online/examRecord/examRecordInfo/lookPositionInfo', component: PersonInfoDetail },
      { key: 'examGradeTOPositionInfo', title: '查看任职', path: '/online/examRecord/examGradeInfo/lookPositionInfo', component: PersonInfoDetail },
      { key: 'examRecordInfo', title: '考试记录查看', path: '/online/examRecord/examRecordInfo', component: ExamRecordInfo },
      { key: 'examGradeInfo', title: '成绩查看', path: '/online/examRecord/examGradeInfo', component: ExamGradeInfo },
      { key: 'examRecordTOLook', title: '考试预览', path: '/online/examRecord/examInfo', component: ExamInfo },
      { key: 'examRecord', title: '考试记录管理', path: '/online/examRecord', component: ExamRecordManager },
      { key: 'examChapter', title: '考试章节', path: '/online/exam/examChapter', component: ExamChapter},
      { key: 'examDetail', title: '新增考试', path: '/online/exam/examDetailAdd', component: ExamDetail, cached: true },
      { key: 'examDetail', title: '考试预览', path: '/online/exam/examInfo', component: ExamInfo },
      { key: 'examAuth', title: '受众设置', path: '/online/exam/examAuth', component: ExamAuth },

      { key: 'examGradeInfo', title: '成绩查看', path: '/online/exam/examGradeInfo', component: ExamGradeInfo },
      { key: 'examLook', title: '查看关联考试', path: '/interact/activity/activityDetailToPart/activityPartLook/toExam', component: ExamLook },
      { key: 'examLook', title: '查看考试', path: '/online/exam/examLook', component: ExamLook },
      { key: 'examDetail', title: '编辑考试', path: '/online/exam/examDetailUpd', component: ExamDetail, cached: true },
      { key: 'exam', title: '考试安排管理', path: '/online/exam', component: Exam },
      { key: 'subjectiveReview', title: '人工批阅', path: '/online/subjectiveReview', component: SubjectiveReview },
      { key: 'examinationRecord', title: '学员考试记录', path: '/online/subjectiveReview/record', component: ExaminationRecord },

      //考试模版
      { key: 'examTemplateLook', title: '查看考试模版', path: '/online/examTemplate/examTemplateLook', component: ExamTemplateLook },
      { key: 'examTemplateChapter', title: '编辑考试模版', path: '/online/examTemplate/examTemplateChapterUpd', component: ExamTemplateChapter, },
      { key: 'examTemplateChapter', title: '新增考试模版', path: '/online/examTemplate/examTemplateChapterAdd', component: ExamTemplateChapter },
      { key: 'examTemplateDetail', title: '编辑考试模版', path: '/online/examTemplate/examTemplateDetailUpd', component: ExamTemplateDetail, cached: true },
      { key: 'examTemplateDetail', title: '新增考试模版', path: '/online/examTemplate/examTemplateDetailAdd', component: ExamTemplateDetail, cached: true  },
      { key: 'examTemplate', title: '考试模版列表', path: '/online/examTemplate', component: ExamTemplate },

      //考试模版组
      { key: 'examTempGroupManage', title: '考试模版组管理', path: '/online/examTemplateGroup/examTempGroupManage', component: ExamTempGroupManage },
      { key: 'examAuth', title: '受众设置', path: '/online/examTemplateGroup/examTemplateAuth', component: ExamAuth },
      { key: 'examTemplateGroupInfo', title: '查看考试模版组', path: '/online/examTemplateGroup/examTemplateGroupInfo', component: ExamTemplateGroupInfo },
      { key: 'examTemplateGroupDetail', title: '编辑考试模版组', path: '/online/examTemplateGroup/examTemplateGroupDetailUpd', component: ExamTemplateGroupDetail, },
      { key: 'examTemplateGroupDetail', title: '新增考试模版组', path: '/online/examTemplateGroup/examTemplateGroupDetailAdd', component: ExamTemplateGroupDetail },
      { key: 'examTemplateGroup', title: '考试模版组管理', path: '/online/examTemplateGroup', component: ExamTemplateGroup },


      //直播，重置版
      { key: 'assessmentRulesList', title: '考核规则管理', path: '/live/liveList/liveTrain/assessmentRulesList', component: AssessmentRulesList },

      { key: 'dealerRuleImport', title: '导入考核经销商', path: '/live/liveList/liveStatisticsList/dealerRuleImport', component: DealerRuleImport },
      { key: 'liveRecordList', title: '查看参训记录', path: '/live/liveList/liveStatisticsList/LiveRecordList', component: LiveRecordList },
      { key: 'assessmentRulesList', title: '考核规则管理', path: '/live/liveList/liveStatisticsList/assessmentRulesList', component: AssessmentRulesList },
      { key: 'liveStatisticsTrainReport', title: '参训统计', path: '/live/liveList/liveStatisticsList/liveTrainReport', component: TrainReport },
      { key: 'liveStatisticsList', title: '参训统计管理', path: '/live/liveList/liveStatisticsList', component: LiveStatisticsList },
      { key: 'liveTrainReport', title: '参训统计', path: '/live/liveList/liveTrainReport', component: TrainReport },
      { key: 'liveRecordList', title: '查看参训记录', path: '/live/liveList/LiveRecordList', component: LiveRecordList },
      { key: 'liveTrain', title: '参训统计', path: '/live/liveList/liveTrainReport', component: TrainReport },
      { key: 'lookPositionInfo', title: '查看任职', path: '/live/liveList/lookPositionInfo', component: PersonInfoDetail },
      { key: 'liveInfo', title: '查看直播', path: '/live/liveList/liveInfo', component: LiveInfo },
      { key: 'liveDetail', title: '编辑直播', path: '/live/liveList/liveUpd', component: LiveDetail, cached: true },
      { key: 'liveDetail', title: '新增直播', path: '/live/liveList/liveAdd', component: LiveDetail, cached: true },

      { key: 'hostLiveRecordList', title: '查看参训记录', path: '/live/hostList/liveRecordList', component: HostLiveRecordList },

      { key: 'liveList', title: '直播管理', path: '/live/liveList', component: LiveList },
      { key: 'hostList', title: '开启直播管理', path: '/live/hostList', component: HostList },


      { key: 'resourcesLiveList', title: '资源直播列表', path: '/interactLiveResources/liveList', component: ResourcesLiveList },
      { key: 'interactLiveResources', title: '中目直播资源账号管理', path: '/interactLiveResources', component: InteractLiveResources },

      //正常经销商
      { key: 'normalDealerList', title: '正常经销商管理', path: '/normalDealer/normalDealerList', component: NormalDealerList },

      //线下培训课程
      { key: 'OfflineProgramDetail', title: '新增课程', path: '/face/offlineProgramList/offlineProgramDetailAdd', component: OfflineProgramDetail, cached: true },
      { key: 'OfflineProgramDetail', title: '编辑课程', path: '/face/offlineProgramList/offlineProgramDetailUpd', component: OfflineProgramDetail, cached: true },
      { key: 'OfflineProgramList', title: '培训主题管理', path: '/face/offlineProgramList', component: OfflineProgramList },

      //签到
      { key: 'SignInList', title: '签到详情', path: '/face/classList/classAideDetail/signInList', component: SignInList },

      //线下培训班级
      { key: 'surveyRecordInfo', title: '问卷收集记录', path: '/face/classList/classAideDetail/classStudentSurveyList/surveyRecordInfo', component: SurveyRecordInfo },
      { key: 'surveyRecordInfoDetail', title: '查看问卷详情', path: '/face/classList/classAideDetail/classStudentSurveyList/surveyRecordInfoDetail', component: SurveyRecordInfoDetail },
      { key: 'ClassStudentHomeworkList', title: '作业查看', path: '/face/classList/classAideDetail/classStudentHomeworkList', component: ClassStudentHomeworkList },
      { key: 'ClassStudentInteractLiveList', title: '参训记录', path: '/face/classList/classAideDetail/classStudentInteractLiveList', component: ClassStudentInteractLiveList },
      { key: 'ClassStudentInteractLiveList', title: '网络小课堂记录', path: '/face/classList/classAideDetail/classStudentNEVInteractLiveList', component: ClassStudentInteractLiveList },
      { key: 'ClassStudentInteractLiveList', title: '远程评估记录', path: '/face/classList/classAideDetail/classStudentRemoteEvaluationList', component: ClassStudentInteractLiveList },
      { key: 'ClassStudentRemoteAuthList', title: '远程认证管理', path: '/face/classList/classAideDetail/classStudentRemoteAuthList', component: ClassStudentRemoteAuthList },
      { key: 'ClassStudentNEVRemoteAuthList', title: 'NEV认证管理', path: '/face/classList/classAideDetail/classStudentNEVRemoteAuthList', component: ClassStudentNEVRemoteAuthList },
      { key: 'ClassStudentSurveyList', title: '满意度问卷记录', path: '/face/classList/classAideDetail/classStudentSurveyList', component: ClassStudentSurveyList },
      { key: 'ClassStudentExamList', title: '考试记录', path: '/face/classList/classAideDetail/classStudentExamList', component: ClassStudentExamList },
      { key: 'ClassStudentProgramList', title: '在线课程学习记录', path: '/face/classList/classAideDetail/classStudentProgramList', component: ClassStudentProgramList },
      { key: 'ClassStudentContentList', title: '资讯记录', path: '/face/classList/classAideDetail/classStudentContentList', component: ClassStudentContentList },
      { key: 'classResultFileImport', title: '班级学员成绩导入', path: '/face/classList/classResult/classResultFileImport', component: ClassResultFileImport },
      { key: 'LookClassInfo', title: '查看班级', path: '/face/classList/lookClassInfo', component: LookClassInfo },
      { key: 'ClassDetail', title: '新增班级', path: '/face/classList/classDetailAdd', component: ClassDetail, cached: true },
      { key: 'ClassDetail', title: '新增班级', path: '/face/classList/classDetailCopy', component: ClassDetail },
      { key: 'ClassDetail', title: '编辑班级', path: '/face/classList/classDetailUpd', component: ClassDetail, cached: true  },

      { key: 'ClassResult', title: '成绩管理', path: '/workflow/apply/applyPlanClass/classResult', component: ClassResult },

      { key: 'ClassResult', title: '成绩管理', path: '/face/classList/classResult', component: ClassResult },
      { key: 'examinationRecord', title: '批阅考试', path: '/face/classList/classAideDetail/subjectiveReviewJump', component: ExaminationRecord },
      { key: 'homeworkRecordReviewList', title: '批阅作业', path: '/face/classList/classAideDetail/homeworkRecordReviewJump', component: HomeworkRecordReviewList },
      { key: 'ClassAideDetail', title: '课堂助手', path: '/face/classList/classAideDetail', component: ClassAideDetail },
      { key: 'ClassStudentList', title: '班级学员', path: '/face/classList/classStudentList', component: ClassStudentList },
      { key: 'ClassStudentList', title: '入店扫码记录', path: '/face/classList/classStudentQrList', component: ClassStudentQrList },
      { key: 'ClassStudentDetail', title: '班级学员查看', path: '/face/classList/classStudentDetail', component: ClassStudentDetail },
      { key: 'ClassList', title: '班级管理', path: '/face/classList', component: ClassList },
      { key: 'ClassAnnouncement', title: '班级公告', path: '/face/classList/announcement', component: ClassAnnouncement },
      { key: 'ClassAlbum', title: '班级相册', path: '/face/classList/album', component: ClassAlbum },
      { key: 'ClassComment', title: '班级评论', path: '/face/classList/comment', component: Comment },

      //消息管理

      { key: 'MessageTaskDetail', title: '新增消息任务', path: '/message/MessageTask/MessageTaskDetail', component: MessageTaskDetail, cached: true  },
      { key: 'MessageTask', title: '消息任务管理', path: '/message/MessageTask', component: MessageTask },

      // 问卷
      { key: 'surveyPreview', title: '问卷预览', path: '/biz/survey/surveyPreview', component: SurveyPreview },
      { key: 'surveyRecordInfoDetail', title: '查看问卷详情', path: '/biz/survey/surveyRecordInfo/surveyRecordInfoDetail', component: SurveyRecordInfoDetail },
      { key: 'surveyRecordInfo', title: '问卷记录', path: '/biz/survey/surveyRecordInfo', component: SurveyRecordInfo },
      { key: 'surveyDetail', title: '编辑问卷', path: '/biz/survey/surveyDetailUpd', component: SurveyDetail, cached: true },
      { key: 'surveyDetail', title: '新增问卷', path: '/biz/survey/surveyDetailAdd', component: SurveyDetail, cached: true },
      { key: 'survey', title: '问卷管理', path: '/biz/survey', component: SurveyManager },

      { key: 'surveyTemplatePreview', title: '问卷模版预览', path: '/biz/surveyTemplate/surveyTemplatePreview', component: SurveyTemplatePreview },
      { key: 'surveyTemplateDetail', title: '编辑模版', path: '/biz/surveyTemplate/surveyTemplateDetailUpd', component: SurveyTemplateDetail, cached: true },
      { key: 'surveyTemplateDetail', title: '新增模版', path: '/biz/surveyTemplate/surveyTemplateDetailAdd', component: SurveyTemplateDetail, cached: true },
      { key: 'surveyTemplate', title: '问卷模版管理', path: '/biz/surveyTemplate', component: SurveyTemplateManager },

      // { key: 'trainCenter', title: '培训中心管理', path: '/face/trainCenter', component: TrainCenterManager },
      // { key: 'classroomDetail', title: '编辑教室', path: '/face/classroom/classroomUpd', component: ClassroomDetail },
      // { key: 'classroomDetail', title: '新增教室', path: '/face/classroom/classroomAdd', component: ClassroomDetail },
      // { key: 'classroom', title: '教室管理', path: '/face/classroom', component: Classroom },
      // { key: 'trainSiteDetail', title: '编辑教室', path: '/face/trainSite/trainSiteDetailUpd', component: TrainSiteDetail },
      // { key: 'trainSiteDetail', title: '新增教室', path: '/face/trainSite/trainSiteDetailAdd', component: TrainSiteDetail },
      // { key: 'trainSite', title: '培训中心场地设置', path: '/face/trainSite', component: TrainSiteManager },


      //岗位能力评估
      { key: 'studentAbilityItemImport', title: '学员岗位能力评估导入', path: '/train/studentAbilityList/studentAbilityFileImport', component: StudentAbilityFileImport },
      { key: 'studentAbilityItemDetailAdd', title: '新增学员岗位能力评估', path: '/train/studentAbilityList/studentAbilityItemDetailAdd', component: StudentAbilityItemDetail },
      { key: 'abilityCheckItemDetail', title: '新增能力评估星级', path: '/train/abilityCheckCategory/abilityCheckItem/abilityCheckItemAdd', component: AbilityCheckItemDetail },
      { key: 'abilityCheckItemDetail', title: '编辑能力评估星级', path: '/train/abilityCheckCategory/abilityCheckItem/abilityCheckItemUpd', component: AbilityCheckItemDetail, },
      { key: 'abilityCheckItemList', title: '能力评估星级管理', path: '/train/abilityCheckCategory/abilityCheckItem', component: AbilityCheckItemList },
      { key: 'abilityCheckCategoryDeatil', title: '编辑能力考核项', path: '/train/abilityCheckCategory/categoryDetailUpd', component: AbilityCheckCategoryDetail, },
      { key: 'abilityCheckCategoryDeatil', title: '新增能力考核项', path: '/train/abilityCheckCategory/categoryDetailAdd', component: AbilityCheckCategoryDetail },
      { key: 'abilityCheckCategoryList', title: '岗位能力管理', path: '/train/abilityCheckCategory', component: AbilityCheckCategoryList },
      { key: 'studentAbilityList', title: '学员岗位能力评估', path: '/train/studentAbilityList', component: StudentAbilityList },
      { key: 'abilityAssess', title: '岗位能力评估', path: '/train/abilityAssess', component: AbilityAssess },
      //流程
      { key: 'modelList', title: '流程模型', path: '/workflow/modelList', component: ModelList },
      { key: 'procdefList', title: '流程版本', path: '/workflow/procdefList', component: ProcdefList },
      { key: 'workflowAudit', title: '流程管理', path: '/workflow/workflowAudit', component: WorkflowAudit },
      { key: 'workflowAuditDetail', title: '审核流程详情', path: '/workflow/workflowAuditDetail', component: WorkflowAuditDetail },
      { key: 'procinsRun', title: '运行中任务列表', path: '/workflow/procinsRun', component: ProcinsRun },
      { key: 'procinsEnd', title: '结束的任务列表', path: '/workflow/procinsEnd', component: ProcinsEnd },
      { key: 'procTaskTodo', title: '待办任务', path: '/workflow/procTaskTodo', component: ProcTaskTodo },
      { key: 'procTaskDone', title: '已办任务', path: '/workflow/procTaskDone', component: ProcTaskDone },
      { key: 'auditDetail', title: '审核', path: '/workflow/auditDetail', component: AuditDetail },
      { key: 'auditHistory', title: '审核', path: '/workflow/auditHistory', component: AuditHistory },
      { key: 'auditHistory', title: '审核', path: '/workflow/managerAuditHistory', component: AuditHistory },


      //报名管理
      { key: 'studentGradesFileImport', title: '学员成绩导入', path: '/workflow/apply/applyPlanClass/importStudentGrades', component: StudentGradesFileImport },
      { key: 'applyPlan', title: '计划安排管理', path: '/workflow/apply/applyPlanNormal', component: ApplyPlanNormal },
      { key: 'applyPlan', title: '计划安排管理', path: '/workflow/apply/applyPlanClass', component: ApplyPlanClass },
      { key: 'applySurveyInfoInfoDetail', title: '查看问卷详情', path: '/workflow/apply/applyInfo/surveyRecordInfoDetail', component: SurveyRecordInfoDetail },
      { key: 'applyInfoTOPositionInfo', title: '查看任职', path: '/workflow/apply/applyInfo/lookPositionInfo', component: PersonInfoDetail },
      { key: 'applyRecordTOPositionInfo', title: '查看任职', path: '/workflow/apply/applyManager/lookPositionInfo', component: PersonInfoDetail },
      { key: 'applyManager', title: '报名记录管理', path: '/workflow/apply/applyManager', component: ApplyManager, },
      { key: 'applyStepsAdd', title: '新增报名', path: '/workflow/apply/applyDetailAdd', component: ApplySteps, cached: true },
      { key: 'applyStepsEdit', title: '编辑报名', path: '/workflow/apply/applyDetailUpd', component: ApplySteps, cached: true },
      { key: 'applyInfo', title: '查看报名', path: '/workflow/apply/applyInfo', component: ApplyInfo },
      { key: 'applyInfoTOVerifyInfo', title: '报名详情查看', path: '/workflow/apply/applyManager/lookVerifyInfo', component: ApplyVerify },
      { key: 'applyVerify', title: '审核详情查看', path: '/workflow/applyVerify/verify', component: ApplyVerify },
      { key: 'applyVerifyLookIden', title: '查看任职', path: '/workflow/applyVerify/lookPositionInfo', component: PersonInfoDetail, },
      { key: 'applyVerifyList', title: '报名审核管理', path: '/workflow/applyVerify', component: ApplyVerifyList, },
      { key: 'apply', title: '报名管理', path: '/workflow/apply', component: Apply },

      //远程认证 旧平台 不能用/face会和线下培训冲突导致菜单展开
      { key: 'remoteAuthFileImport', title: '考卷上传', path: '/remoteAuth/remoteAuthList/remoteAuthFileImport', component: RemoteAuthFileImport },
      { key: 'remoteAuthScoreFileImport', title: '认证管理成绩导入', path: '/remoteAuth/remoteAuthList/remoteAuthScoreFileImport', component: RemoteAuthScoreFileImport },

      //NEV认证管理
      { key: 'competencyCertificationModel', title: '能力认证模型', path: '/remoteAuth/nevRemoteAuthDetailList/score', component: CompetencyCertificationModel},
      { key: 'nevRemoteAuthScore', title: '认证评分', path: '/remoteAuth/lectureNevAuthDetail/score', component: NevRemoteAuthScore },
      { key: 'lectureNevAuthDetail', title: 'NEV认证', path: '/remoteAuth/lectureNevAuthDetail', component: LectureNevAuthDetailList },
      { key: 'nevRemoteAuthDetail', title: 'NEV认证详情管理', path: '/remoteAuth/remoteAuthList/nevRemoteAuthDetail', component: NevRemoteAuthDetailList },
      { key: 'nevRemoteAuthDetailList', title: 'NEV认证详情管理', path: '/remoteAuth/nevRemoteAuthDetailList', component: NevRemoteAuthDetailList },

      //远程认证管理
      { key: 'studentRemoteAuthScoreImport', title: '认证详情成绩导入', path: '/remoteAuth/remoteAuthList/studentRemoteAuthDetailList/studentRemoteAuthScoreImport', component: StudentRemoteAuthScoreImport },
      { key: 'studentRemoteAuthScoreImport', title: '认证详情成绩导入', path: '/face/classList/classAideDetail/classStudentRemoteAuthList/studentRemoteAuthScoreImport', component: StudentRemoteAuthScoreImport },
      { key: 'studentRemoteAuthDetailList', title: '认证详情管理', path: '/remoteAuth/remoteAuthList/studentRemoteAuthDetailList', component: StudentRemoteAuthDetailList },
      { key: 'remoteAuthDetail', title: '新增认证', path: '/remoteAuth/remoteAuthList/remoteAuthDetailAdd', component: RemoteAuthDetail },
      { key: 'remoteAuthDetail', title: '编辑认证', path: '/remoteAuth/remoteAuthList/remoteAuthDetailUpd', component: RemoteAuthDetail, },
      { key: 'remoteAuthList', title: '检核项目管理', path: '/remoteAuth/remoteAuthList', component: RemoteAuthList },
      { key: 'studentRemoteAuthScore', title: '修改成绩', path: '/remoteAuth/studentRemoteAuthDetailList/studentRemoteAuthScore', component: StudentRemoteAuthScore },
      { key: 'studentRemoteAuthDetailList', title: '认证详情管理', path: '/remoteAuth/studentRemoteAuthDetailList', component: StudentRemoteAuthDetailList },
      //远程评估
      { key: 'orgRemoteEvaluationInteractLiveList', title: '参训统计', path: '/remoteAuth/orgRemoteEvaluationDetailList/orgRemoteEvaluationInteractLiveList', component: OrgRemoteEvaluationInteractLiveList },
      { key: 'orgRemoteEvaluationScoreImport', title: '远程评估详情成绩导入', path: '/remoteAuth/orgRemoteEvaluationDetailList/orgRemoteEvaluationScoreImport', component: OrgRemoteEvaluationScoreImport },
      { key: 'orgRemoteEvaluationDetailList', title: '远程评估详情管理', path: '/remoteAuth/remoteAuthList/orgRemoteEvaluationDetailList', component: OrgRemoteEvaluationDetailList },
      { key: 'orgRemoteEvaluationDetailInfo', title: '查看远程评估详情', path: '/remoteAuth/orgRemoteEvaluationDetailList/orgRemoteEvaluationDetailInfo', component: OrgRemoteEvaluationDetailInfo },
      { key: 'orgRemoteEvaluationDetail', title: '新增远程评估详情', path: '/remoteAuth/orgRemoteEvaluationDetailList/orgRemoteEvaluationDetailAdd', component: OrgRemoteEvaluationDetail },
      { key: 'orgRemoteEvaluationDetail', title: '编辑远程评估详情', path: '/remoteAuth/orgRemoteEvaluationDetailList/orgRemoteEvaluationDetailUpd', component: OrgRemoteEvaluationDetail },
      { key: 'orgRemoteEvaluationScore', title: '修改成绩', path: '/remoteAuth/orgRemoteEvaluationDetailList/orgRemoteEvaluationScore', component: OrgRemoteEvaluationScore },
      { key: 'orgRemoteEvaluationDetailList', title: '远程评估详情管理', path: '/remoteAuth/orgRemoteEvaluationDetailList', component: OrgRemoteEvaluationDetailList },

      //应用服务管理
      { key: 'applicationManageToColumnDetail', title: '栏目应用管理', path: '/application/applicationManage/applicationManageToColumnDetail', component: ApplicationColumnManager },
      { key: 'applicationManageDetail', title: '编辑应用服务', path: '/application/applicationManage/applicationManageDetailUpd', component: ApplicationManageDetail, cached: true },
      { key: 'applicationManageDetail', title: '新增应用服务', path: '/application/applicationManage/applicationManageDetailAdd', component: ApplicationManageDetail, cached: true },
      { key: 'applicationManageLook', title: '查看应用服务', path: '/application/applicationManage/applicationManageLook', component: ApplicationManageLook },
      { key: 'applicationManage', title: '应用服务管理', path: '/application/applicationManage', component: ApplicationManageInfo },
      //栏目应用管理
      { key: 'applicationColumnRecord', title: '记录管理', path: '/application/applicationColumn/applicationColumnRecord', component: ApplicationColumnRecord },
      { key: 'applicationColumnLook', title: '查看栏目应用', path: '/application/applicationColumn/applicationColumnLook', component: ApplicationColumnLook },
      { key: 'applicationColumnDetail', title: '编辑栏目应用', path: '/application/applicationColumn/applicationColumnDetailUpd', component: ApplicationColumnDetail, cached: true  },
      { key: 'applicationColumnDetail', title: '新增栏目应用', path: '/application/applicationColumn/applicationColumnDetailAdd', component: ApplicationColumnDetail, cached: true },
      { key: 'applicationColumn', title: '栏目应用管理', path: '/application/applicationColumn', component: ApplicationColumnManager },

      /**
       * 社区管理
       */
      //话题管理
      { key: 'topicFollow', title: '关注列表', path: '/community/topic/follow', component: TopicFollow },
      { key: 'topicInvitation', title: '帖子列表', path: '/community/topic/invitation', component: InvitationManager },
      { key: 'topicLook', title: '查看话题', path: '/community/topic/topicLook', component: TopicLook },
      { key: 'topicAdd', title: '新增话题', path: '/community/topic/topicAdd', component: TopicDetail },
      { key: 'topicUpd', title: '编辑话题', path: '/community/topic/topicUpd', component: TopicDetail, },
      { key: 'topic', title: '话题管理', path: '/community/topic', component: Topic },
      //帖子管理
      { key: 'invitation', title: '帖子点赞信息', path: '/interact/community/invitation/invitationAgree', component: OperateRecord },
      { key: 'invitation', title: '帖子点踩信息', path: '/interact/community/invitation/invitationStep', component: OperateRecord },
      { key: 'invitation', title: '帖子评论信息', path: '/interact/community/invitation/invitationComment', component: Comment },
      { key: 'invitation', title: '帖子转发信息', path: '/interact/community/invitation/invitationTranspond', component: InvitationManager },
      { key: 'invitationLook', title: '查看帖子', path: '/interact/community/invitation/invitationLook', component: InvitationLook },
      { key: 'invitationDetail', title: '新增帖子', path: '/interact/community/invitation/invitationDetailAdd', component: InvitationDetail },
      { key: 'invitation', title: '帖子管理', path: '/interact/community/invitation', component: InvitationManager },
      //

      //活动管理
      { key: 'activityMessageDetail', title: '编辑活动公告', path: '/interact/activity/activityMessage/activityMessageDetailUpd', component: ActivityMessageDetail, },
      { key: 'activityMessageDetail', title: '新增活动公告', path: '/interact/activity/activityMessage/activityMessageDetailAdd', component: ActivityMessageDetail },
      { key: 'activityMessage', title: '活动公告管理', path: '/interact/activity/activityMessage', component: ActivityMessageManager },
      { key: 'topicLook', title: '查看话题', path: '/interact/activity/activityTopic/topicLook', component: TopicLook },
      { key: 'activityTopic', title: '关联话题', path: '/interact/activity/activityTopic', component: ActivityTopic },
      { key: 'activityPartLook', title: '查看活动环节', path: '/interact/activity/activityDetailToPart/activityPartLook', component: ActivityPartLook },
      { key: 'activityPartDetail', title: '编辑活动环节', path: '/interact/activity/activityDetailToPart/activityPartDetailUpd', component: ActivityPartDetail, },
      { key: 'activityPartDetail', title: '新增活动环节', path: '/interact/activity/activityDetailToPart/activityPartDetailAdd', component: ActivityPartDetail },
      { key: 'activityPart', title: '活动环节管理', path: '/interact/activity/activityDetailToPart', component: ActivityPartManager },
      { key: 'activityLook', title: '查看活动信息', path: '/interact/activity/activityLook', component: ActivityLook },
      { key: 'activityDetail', title: '编辑活动', path: '/interact/activity/activityDetailUpd', component: ActivityDetail, },
      { key: 'activityDetail', title: '新增活动', path: '/interact/activity/activityDetailAdd', component: ActivityDetail },
      { key: 'activity', title: '活动管理', path: '/interact/activity', component: ActivityManager },

      //组件案例展示
      { key: 'listselect', title: '人员列表', path: '/demo/list/listselect', component: ListSelect },
      { key: 'addSection', title: '新增章节', path: '/demo/addSection', component: AddSection },
      { key: 'showSubject', title: '题目查看', path: '/demo/showSubject', component: ShowSubject },
      { key: 'subjectForm', title: '题目查看', path: '/demo/subjectForm', component: SubjectForm },
      { key: 'browserExport', title: '导出表格', path: '/demo/browserExport', component: BrowserExport },
      { key: 'upload', title: '导入表格', path: '/demo/upload', component: Upload },
      { key: 'charts', title: '图表', path: '/demo/charts', component: Charts },
      { key: 'steps', title: '步骤条', path: '/demo/steps', component: Steps },
      { key: 'anchor', title: '锚点', path: '/demo/anchor', component: Anchor },
      { key: 'examPreview', title: '考试预览', path: '/demo/examPreview', component: ExamPreview },
      { key: 'questionPreview', title: '问卷预览', path: '/demo/questionPreview', component: QuestionPreview },
      { key: 'questionResult', title: '问卷详情', path: '/demo/questionResult', component: QuestionResult },
      { key: 'treeSelectList', title: '树形选择列表', path: '/demo/treeSelectList', component: TreeSelectList },
      { key: 'questionnair', title: '问卷', path: '/demo/questionnair', component: Questionnair },
      { key: 'examPercent', title: '考试环形图demo', path: '/demo/examPercent', component: ExamPercent },
      { key: 'formLinks', title: '表单及联', path: '/demo/formLinks', component: FormLinks },
      { key: 'iframe', title: 'Iframe', path: '/demo/iframe', component: Iframe },
      { key: 'ossUpload', title: 'oss上传', path: '/demo/ossUpload', component: OssUpload },
      { key: 'cropper', title: '裁剪图片', path: '/demo/cropper', component: Cropper },
      { key: 'wizLocationSelect', title: '省市选择', path: '/demo/wizLocationSelect', component: WizLocationSelectDemo },
      { key: 'wizCalendar', title: '日历', path: '/demo/wizCalendar', component: WizCalendarDemo },
      { key: 'dataAuthSelect', title: '数据权限选择组件', path: '/demo/dataAuthSelect', component: DataAuthSelect },
      { key: 'wizAuthority', title: '数据权限(升级版)', path: '/demo/wizAuthority', component: WizAuthorityDemo },
      { key: 'editeorDemo', title: '富文本编辑器', path: '/demo/editeorDemo', component: EditeorDemo },
      { key: 'Copy', title: '复制到剪贴板', path: '/demo/copy', component: Copy },
      { key: 'Image', title: '图片组件', path: '/demo/image', component: Image },
      { key: 'StuTabs', title: '学员端选项卡', path: '/demo/stutabs', component: StuTabs },
      { key: 'TableToExcel', title: '表格直接下载Excel', path: '/demo/tableToExcel', component: TableToExcel },

      { key: 'highSetDemo', title: '高级设置', path: '/demo/highSetDemo', component: HighSetDemo },

      { key: 'positionRadar', title: '岗位能力评估雷达图', path: '/demo/positionRadar', component: PositionRadarDemo },

      //路径
      { key: 'trainPathFileImport', title: '培训路径导入', path: '/trainPath/trainPathFileImport', component: TrainPathFileImport },
      { key: 'trainPathDetail', title: '新增培训路径', path: '/trainPath/trainPathAdd', component: TrainPathDetail,cached: true },
      { key: 'trainPathDetail', title: '编辑培训路径', path: '/trainPath/trainPathUpd', component: TrainPathDetail,cached: true },
      { key: 'trainPathStage', title: '路径阶段管理', path: '/trainPath/trainPathStage', component: TrainPathStage },
      { key: 'lookTrainPath', title: '查看', path: '/trainPath/lookTrainPath', component: LookTrainPath },
      { key: 'studentTrainPathList', title: '学员列表', path: '/trainPath/studentTrainPathList', component: StudentTrainPathList },
      { key: 'trainPathList', title: '培训路径管理', path: '/trainPath', component: TrainPathList },
      { key: 'trainPathSeriesContentList', title: '系列化课程内容管理', path: '/trainPath/seriesContentList', component: SeriesContentList },

      //路径成绩计算规则
      { key: 'trainPathStageScoreRule', title: '路径成绩规则', path: '/trainPathStageScoreRule', component: trainPathStageScoreRule },
      { key: 'trainPathStageScoreRuleDetail', title: '路径成绩规则新增', path: '/trainPathStageScoreRule/trainPathStageScoreRuleAdd', component: trainPathStageScoreRuleDetail, cached: true },
      { key: 'trainPathStageScoreRuleDetail', title: '路径成绩规则编辑', path: '/trainPathStageScoreRule/trainPathStageScoreRuleUpd', component: trainPathStageScoreRuleDetail, cached: true },

      //评论管理

      { key: 'commentManage', title: '评论管理', path: '/commentManage', component: Comment },

      //路径评语
      { key: 'trainPathCommentDetail', title: '新增评语', path: '/comment/trainPathCommentAdd', component: TrainPathCommentDetail, cached: true },
      { key: 'trainPathCommentDetail', title: '编辑评语', path: '/comment/trainPathCommentUpd', component: TrainPathCommentDetail, cached: true },
      { key: 'lookComment', title: '查看评语', path: '/comment/lookComment', component: LookComment },
      { key: 'trainPathCommentAudit', title: '评语审核管理', path: '/comment/trainPathCommentAudit', component: StudentCommentAudit },
      { key: 'auditComment', title: '评语审核', path: '/comment/auditComment', component: AuditComment },
      { key: 'trainPathCommentList', title: '评语管理', path: '/comment', component: TrainPathCommentList },

      //认证、证书
      { key: 'certDetail', title: '新增证书', path: '/cert/certList/certAdd', component: CertDetail, cached: true },
      { key: 'certDetail', title: '编辑证书', path: '/cert/certList/certUpd', component: CertDetail, cached: true },
      { key: 'certInfo', title: '查看证书', path: '/cert/certList/certInfo', component: CertInfo },
      { key: 'certList', title: '证书管理', path: '/cert/certList', component: CertList },

      //证书路径阶段数据配置
      { key: 'certStageList', title: '证书路径阶段数据修复', path: '/cert/certStageList', component: CertStageList },

      // 认证证书统计
      { key: 'certificateStatistics', title: '经销商认证率统计', path: '/certificateStatistics/list', component: CertificateStatistics },
      { key: 'certificateStatisticsCfg', title: '经销商认证报表配置', path: '/certificateStatisticsCfg/list', component: CertificateStatisticsCfg },

      //个人证书
      { key: 'certPersonInfoDetail', title: '查看任职', path: '/personalCert/personalCertList/lookPositionInfo', component: PersonInfoDetail },
      { key: 'personalCertDetail', title: '新增个人证书', path: '/personalCert/personalCertList/personalCertAdd', component: PersonalCertIDetail, cached: true  },
      { key: 'personalCertDetail', title: '编辑个人证书', path: '/personalCert/personalCertList/personalCertUpd', component: PersonalCertIDetail, cached: true  },
      { key: 'personalCertInfo', title: '查看个人证书', path: '/personalCert/personalCertList/personalCertInfo', component: PersonalCertInfo },
      { key: 'personalCertList', title: '个人证书记录管理', path: '/personalCert/personalCertList', component: PersonalCertList },
      { key: 'certImport', title: '个人证书导入', path: '/personalCert/certImport', component: CertImport },

      //证书挂靠
      { key: 'certLinkList', title: '证书挂靠管理', path: '/certLink/certLinkList', component: CertLinkList },
      { key: 'certLinkList', title: '导入', path: '/certLink/certLinkImport', component: CertLinkImport },

      //证书申请管理
      { key: 'certApplyAuditDetail', title: '申请信息审核', path: '/certApply/certApplyList/certApplyAuditDetail', component: CertApplyAuditDetail },
      { key: 'certApplyAuditDetail', title: '查看审核信息', path: '/certApply/certApplyList/certApplyAuditDetailShow', component: CertApplyAuditDetail },
      { key: 'certApplyList', title: '证书申请管理', path: '/certApply/certApplyList', component: CertApplyList },
      { key: 'certDetail', title: '证书中心', path: '/cert', component: CertDetail },
      { key: 'certDetail', title: '证书中心', path: '/personalCert', component: CertDetail },
      { key: 'certDetail', title: '证书中心', path: '/certLink', component: CertDetail },
      { key: 'certDetail', title: '证书中心', path: '/certApply', component: CertDetail },

      // 内容
      { key: 'contentDetail', title: '内容新增', path: '/content/contentManage/contentDetailAdd', component: ContentDetail, cached: true },
      { key: 'contentRecord', title: '内容记录管理', path: '/content/contentManage/record', component: ContentRecord },
      { key: 'contentDetail', title: '内容编辑', path: '/content/contentManage/contentDetailUpd', component: ContentDetail, cached: true },
      { key: 'contentView', title: '内容查看', path: '/content/contentManage/view', component: ContentView },
      { key: 'contentPreview', title: '内容预览', path: '/content/contentManage/preview', component: ContentPreview },
      { key: 'contentLabel', title: '内容标签管理', path: '/content/contentLabel/label', component: ContentLabel },
      { key: 'contentManage', title: '内容管理', path: '/content/contentManage', component: ContentManage },

      //任务
      { key: 'taskNotice', title: '任务通知管理', path: '/taskInfo/taskNotice', component: TaskNotice },
      { key: 'taskRecord', title: '任务记录', path: '/taskInfo/record', component: TaskRecord },
      { key: 'taskEdit', title: '新增任务', path: '/taskInfo/add', component: TaskEdit, cached: true },
      { key: 'taskEdit', title: '修改任务', path: '/taskInfo/update', component: TaskEdit, cached: true },
      { key: 'taskInfo', title: '任务中心', path: '/taskInfo', component: TaskInfo },


      //点赞管理
      { key: 'operateRecordManage', title: '点赞踩管理', path: '/operateRecord', component: OperateRecord },

      //推荐管理
      { key: 'featuredPath', title: '推荐路径', path: '/featured/management/featuredLook/featuredTrainPath', component: LookTrainPath },
      { key: 'featuredSurvey', title: '推荐问卷', path: '/featured/management/featuredLook/featuredSurvey', component: SurveyPreview },
      { key: 'featuredExam', title: '推荐考试', path: '/featured/management/featuredLook/featuredExam', component: ExamLook },
      { key: 'featuredTopic', title: '推荐话题', path: '/featured/management/featuredLook/featuredTopic', component: TopicLook },
      { key: 'featuredActivity', title: '推荐活动', path: '/featured/management/featuredLook/featuredActivity', component: ActivityLook },
      { key: 'featuredLook', title: '查看推荐', path: '/featured/management/featuredLook', component: FeaturedLook },
      { key: 'featuredAdd', title: '新增推荐', path: '/featured/management/featuredAdd', component: FeaturedDetail, cached: true },
      { key: 'featuredUpd', title: '编辑推荐', path: '/featured/management/featuredUpd', component: FeaturedDetail, cached: true },
      { key: 'featured', title: '推荐管理', path: '/featured/management', component: Featured },


      //系列话课程
      { key: 'seriesFileImport', title: '系列化课程导入', path: '/series/seriesList/seriesFileImport', component: SeriesFileImport },
      { key: 'seriesContentDetail', title: '新增内容管理', path: '/series/seriesList/seriesContentList/seriesContentDetailAdd', component: SeriesContentDetail },
      { key: 'seriesContentDetail', title: '编辑内容管理', path: '/series/seriesList/seriesContentList/seriesContentDetailUpd', component: SeriesContentDetail, },
      { key: 'seriesContentList', title: '内容管理', path: '/series/seriesList/seriesContentList', component: SeriesContentList },
      { key: 'seriesInfo', title: '查看关联系列化课程', path: '/interact/activity/activityDetailToPart/activityPartLook/toSeries', component: SeriesInfo },
      { key: 'seriesInfo', title: '查看系列化课程', path: '/series/seriesList/seriesInfo', component: SeriesInfo },
      { key: 'seriesDetail', title: '编辑系列化课程', path: '/series/seriesList/seriesDetailUpd', component: SeriesDetail,cached: true },
      { key: 'seriesDetail', title: '新增系列化课程', path: '/series/seriesList/seriesDetailAdd', component: SeriesDetail,cached: true},
      { key: 'seriesProgram', title: '内容分类管理', path: '/series/seriesList/seriesProgram', component: SeriesProgram },
      { key: 'seriesManage', title: '系列化课程管理', path: '/series/seriesList', component: SeriesProgramList },

      //规则中心
      { key: 'ruleLook', title: '规则管理', path: '/rule/configureList/look', component: RuleLook },
      { key: 'ruleConfigureDetail', title: '新增规则配置', path: '/rule/configureList/ruleConfigureDetailAdd', component: RuleConfigureDetail, cached: true },
      { key: 'ruleConfigureDetail', title: '修改规则配置', path: '/rule/configureList/ruleConfigureDetailUpd', component: RuleConfigureDetail, cached: true },
      { key: 'configureList', title: '规则管理', path: '/rule/configureList', component: RuleConfigure },


      //学分管理
      { key: 'subjectCreditRecordList', title: '科目学分记录', path: '/credit/subjectList/subjectCreditRecordList', component: SubjectCreditRecordList },
      { key: 'subjectInfo', title: '查看学分科目信息', path: '/credit/subjectList/SubjectInfo', component: SubjectInfo },
      { key: 'subjectDetail', title: '编辑学分科目信息', path: '/credit/subjectList/subjectDetailUpd', component: SubjectDetail },
      { key: 'subjectDetail', title: '新增学分科目信息', path: '/credit/subjectList/subjectDetailAdd', component: SubjectDetail },
      { key: 'subjectList', title: '学分科目管理', path: '/credit/subjectList', component: SubjectList },
      { key: 'subjectPathList', title: '学分管理', path: '/credit', component: SubjectList },

      //作业管理
      { key: 'homeworkRecordReviewList', title: '批阅作业', path: '/homework/homeworkRecordReviewList', component: HomeworkRecordReviewList },
      { key: 'homeworkRecordList', title: '作业记录', path: '/homework/homeworkList/homeworkRecordList', component: HomeworkRecordList },
      { key: 'homeworkRecordLists', title: '作业记录', path: '/homework/homeworkRecordList', component: HomeworkRecordList },
      // { key: 'homeworkInfo', title: '查看作业', path: '/homework/homeworkList/homeworkListInfo', component: HomeworkInfo },
      { key: 'homeworkDetail', title: '编辑作业', path: '/homework/homeworkList/homeworkUpd', component: HomeworkDetail, cached: true },
      { key: 'homeworkDetail', title: '新增作业', path: '/homework/homeworkList/homeworkAdd', component: HomeworkDetail, cached: true},
      { key: 'homeworkInfo', title: '查看作业', path: '/homework/homeworkList/homeworkInfo', component: HomeworkInfo },
      { key: 'homeworkLabel', title: '作业标签管理', path: '/homework/homeworkLabel/label', component: ContentLabel },
      { key: 'homeworkList', title: '作业管理', path: '/homework/homeworkList', component: HomeworkList },


      // 受众组
      { key: 'audienceGroup', title: '受众组', path: '/audience/group', component: AudienceGroup },
      { key: 'audienceGroupDetailAdd', title: '受众组新增', path: '/audience/group/add', component: AudienceGroupDetail, cached: true },
      { key: 'audienceGroupDetailUpd', title: '受众组编辑', path: '/audience/group/upd', component: AudienceGroupDetail, cached: true },
      { key: 'audienceGroupPriview', title: '受众组查看', path: '/audience/group/preview', component: AudienceGroupPriview },

      // 店内报告
      { key: 'examScoreStatistics', title: '考试成绩明细', path: '/examRecordStatistics/examScoreStatistics', component: ExamScoreStatistics },
      { key: 'orgExaminationStatistics', title: '考试情况组织统计', path: '/examRecordStatistics/orgExaminationStatistics', component: OrgExaminationStatistics },
      { key: 'orgJobExaminationStatistics', title: '考试情况组织岗位统计', path: '/examRecordStatistics/orgJobExaminationStatistics', component: OrgJobExaminationStatistics },
      { key: 'examEverydayRecordStatistics', title: '考试成绩', path: '/examRecordStatistics/examEverydayStatistics/showScore', component: ExamEverydayRecordStatistics },
      { key: 'examEverydayStatistics', title: '天天学练', path: '/examRecordStatistics/examEverydayStatistics', component: ExamEverydayStatistics },
      { key: 'onlineCourseCompletionStatus', title: '在线课程完成情况', path: '/onlineCourseStatistics/onlineCourseCompletionStatus', component: OnlineCourseCompletionStatus },
      { key: 'orgCourseLearningStatistics', title: '在线课程组织完成率', path: '/onlineCourseStatistics/orgCourseLearningStatistics', component: OrgCourseLearningStatistics },
      { key: 'courseLearningStatistics', title: '在线课程完成率', path: '/onlineCourseStatistics/courseLearningStatistics', component: CourseLearningStatistics },
      { key: 'statisticsOfflineTrainees', title: '培训管理学员统计', path: '/offlineTrainingStatistics/statisticsOfflineTrainees', component: StatisticsOfflineTrainees },
      { key: 'offlineTrainingAndCertificationStatistics', title: '培训班级及认证情况统计', path: '/offlineTrainingStatistics/offlineTrainingAndCertificationStatistics', component: OfflineTrainingAndCertificationStatistics },
      { key: 'orgStatisticsOfflineTrainingAndLearning', title: '线下培训组织完成率', path: '/offlineTrainingStatistics/orgStatisticsOfflineTrainingAndLearning', component: OrgStatisticsOfflineTrainingAndLearning },
      { key: 'statisticsOfflineTrainingAndLearning', title: '线下培训主题完成率', path: '/offlineTrainingStatistics/statisticsOfflineTrainingAndLearning', component: StatisticsOfflineTrainingAndLearning },
      { key: 'personnelCertificateAcquisitionDetails', title: '个人证书明细', path: '/certificationStatistics/personnelCertificateAcquisitionDetails', component: PersonnelCertificateAcquisitionDetails },
      { key: 'orgCertificationStatistics', title: '组织认证证书覆盖率', path: '/certificationStatistics/orgCertificationStatistics', component: OrgCertificationStatistics },
      { key: 'personalPathTaskDetails', title: '个人路径阶段完成明细', path: '/pathReport/personalPathTaskDetails', component: PersonalPathTaskDetails },
      { key: 'personalPathCompletion', title: '个人路径完成率', path: '/pathReport/personalPathCompletion', component: PersonalPathCompletion },
      { key: 'orgPathCompletion', title: '组织路径完成率', path: '/pathReport/orgPathCompletion', component: OrgPathCompletion },
      { key: 'personalPathCompletionRate', title: '个人路径完成率统计', path: '/pathReport/personalPathCompletionRate', component: PersonalPathCompletionRate },
      { key: 'orgPathCompletionInfo', title: '组织路径完成率统计', path: '/pathReport/orgPathCompletionInfo', component: OrgPathCompletionInfo },
      { key: 'personalPathTaskCompletion', title: '个人路径任务完成明细', path: '/pathReport/personalPathTaskCompletion', component: PersonalPathTaskCompletion },
      { key: 'personalPathScoreCompletion', title: '个人路径成绩完成明细', path: '/pathReport/personalPathScoreCompletion', component: PersonalPathScoreCompletion },

      { key: 'dimStudentReport', title: '学员维度报表', path: '/report/dimStudentReport', component: DimStudentReport },


      //新开业培训要求
      { key: 'requirementRecord', title: '新开业培训要求记录', path: '/requirement/requirementRecord', component: RequirementRecord },
      { key: 'requirementRecord', title: '新开业培训要求记录', path: '/requirement/requirementList/requirementRecord', component: RequirementRecord },
      { key: 'requirementDetail', title: '新增考核要求信息', path: '/requirement/requirementList/requirementAdd', component: RequirementDetail },
      { key: 'requirementDetail', title: '编辑考核要求信息', path: '/requirement/requirementList/requirementUpd', component: RequirementDetail, },
      { key: 'requirementList', title: '新学员考核要求管理', path: '/requirement/requirementList', component: RequirementList },

      //考核要求字段配置
      { key: 'requirementConfig', title: '新增考核要求名称', path: '/requirementConfig/requirementConfigList/requirementConfigAdd', component: RequirementConfigDetail, },
      { key: 'requirementConfig', title: '编辑考核要求名称', path: '/requirementConfig/requirementConfigList/requirementConfigUpd', component: RequirementConfigDetail, },
      { key: 'requirementConfigList', title: '考核要求名称管理', path: '/requirementConfig/requirementConfigList', component: RequirementConfigList },

      //新开业人员培训
      { key: 'requirementPersonnelApplyList', title: '测评报名管理', path: '/requirementPersonnel/requirementPersonnelList/apply', component: RequirementPersonnelApplyList },
      { key: 'requirementPersonnelDetailList', title: '新开业人员培训详情', path: '/requirementPersonnel/requirementPersonnelList/requirementPersonnelDetailList', component: RequirementPersonnelDetailList },
      { key: 'requirementPersonnelList', title: '新开业人员培训', path: '/requirementPersonnel/requirementPersonnelList', component: RequirementPersonnelList },

      //经销商新人培训
      { key: 'dealerNewPersonTrainDetailList', title: '新人培训详情', path: '/dealerNewPersonTrain/dealerNewPersonTrainList/dealerNewPersonTrainDetailList', component: DealerNewPersonTrainDetailList },
      { key: 'dealerNewPersonTrainList', title: '经销商新人培训', path: '/dealerNewPersonTrain/dealerNewPersonTrainList', component: DealerNewPersonTrainList },
      { key: 'RequirementPartTimePosition', title: '岗位兼职信息', path: '/dealerNewPersonTrain/requirementPartTimePosition', component: RequirementPartTimePosition},
      { key: 'RequirementPartTimePositionDetail', title: '新增岗位兼职信息', path: '/dealerNewPersonTrain/requirementPartTimePositionAdd', component: RequirementPartTimePositionDetail},
      { key: 'RequirementPartTimePositionDetail', title: '编辑岗位兼职信息', path: '/dealerNewPersonTrain/requirementPartTimePositionUpd', component: RequirementPartTimePositionDetail},

      //参训统计
      { key: 'trainingStatisticsRulesList', title: '考核规则管理', path: '/trainingStatistics/trainingStatisticsList/assessmentRulesList', component: AssessmentRulesList },
      { key: 'trainingStatisticsDataReport', title: '参训统计', path: '/trainingStatistics/trainingStatisticsList/dataReport', component: TrainReport },
      { key: 'trainingStatisticsDetailAdd', title: '新增参训统计', path: '/trainingStatistics/trainingStatisticsList/trainingStatisticsAdd', component: TrainingStatisticsDetail },
      { key: 'trainingStatisticsDetailUpd', title: '编辑参训统计', path: '/trainingStatistics/trainingStatisticsList/trainingStatisticsUpd', component: TrainingStatisticsDetail },
      { key: 'trainingStatisticsManagement', title: '参训统计管理', path: '/trainingStatistics/trainingStatisticsList', component: TrainingStatisticsManagement },

      //数据分析报表
      { key: 'tableFieldDetailAdd', title: '表字段新增', path: '/dataReport/tableConfig/tableField/add', component: TableFieldDetail },
      { key: 'tableFieldDetailUpd', title: '表字段编辑', path: '/dataReport/tableConfig/tableField/upd', component: TableFieldDetail },
      { key: 'tableField', title: '表字段管理', path: '/dataReport/tableConfig/tableField', component: TableFieldList },
      { key: 'tableConfig', title: '配置表管理', path: '/dataReport/tableConfig', component: TableConfigList },
      { key: 'reportConfigDetailList', title: '报表详情', path: '/dataReport/reportConfigList/reportConfigDetailList', component: ReportConfigDetailList },
      { key: 'reportConfigAdd', title: '新增报表', path: '/dataReport/reportConfigList/reportConfigAdd', component: ReportConfigForm, cached: true },
      { key: 'reportConfigUpd', title: '编辑报表', path: '/dataReport/reportConfigList/reportConfigUpd', component: ReportConfigForm, cached: true },
      { key: 'reportConfigList', title: '组合报表管理', path: '/dataReport/reportConfigList', component: ReportConfigList },

      //消息通知
      { key: 'noticeRecordDetail', title: '消息通知详情', path: '/message/noticeRecord/noticeRecordDetail', component: NoticeRecordDetail },
      { key: 'noticeRecord', title: '消息通知记录', path: '/message/noticeRecord', component: NoticeRecord },

      //业务受众配置
      { key: 'permissionsManager', title: '业务受众配置', path: '/permissions/list', component: PermissionsManager },
      { key: 'PermissionsAdd', title: '批量设置', path: '/permissions/add', component: PermissionsAdd },

      { key: 'thirdCoprManager', title: '第三方企业管理', path: '/auth/corpManager', component: ThirdCopr},
      { key: 'corpUserManager', title: '第三方应用受众设置', path: '/auth/corpManager/appAuthSetting', component: ThirdAppAuthSetting},
      { key: 'thirdAppManager', title: '第三方应用管理', path: '/auth/corpManager/appManager', component: ThirdApp},
      { key: 'corpUserManager', title: '第三方企业人员管理', path: '/auth/corpManager/userManager', component: ThirdCorpUser},
      { key: 'whitelistManagement', title: '白名单设置', path: '/perm/whitelist', component: WhiteList,cached: true},

      //车联系统
      { key: 'cleExamManager', title: '车联考试', path: '/cle/examManager', component: CleExamManager },
      { key: 'cleExamAdd', title: '车联考试-新增', path: '/cle/examManager/add', component: CleExamDetail },
      { key: 'cleExamUpd', title: '车联考试-编辑', path: '/cle/examManager/upd', component: CleExamDetail },

      //短视频
      { key: 'questionType', title: '短视频分类管理', path: '/biz/categoryType/shortVideo', component: QuestionType },
      { key: 'shortVideoRecord', title: '记录管理', path: '/shortVideo/record', component: ShortVideoRecord},
      { key: 'shortVideoDetail', title: '新增短视频', path: '/shortVideo/shortVideoDetailAdd', component: ShortVideoDetail},
      { key: 'shortVideoInfo', title: '查看', path: '/shortVideo/look', component: ShortVideoLook},
      { key: 'shortVideoManager', title: '短视频管理', path: '/shortVideo', component: ShortVideoManager},

      { key: 'shortVideoScreenToDeal', title: '处理', path: '/shortVideoScreen/record/toDeal', component: ShortVideoScreenToDeal},
      { key: 'shortVideoScreenRecord', title: '举报记录', path: '/shortVideoScreen/record', component: ShortVideoScreenRecordManager},
      { key: 'shortVideoScreenToDeal', title: '处理', path: '/shortVideoScreen/toDeal', component: ShortVideoScreenToDeal},
      { key: 'shortVideoScreenManager', title: '举报管理', path: '/shortVideoScreen', component: ShortVideoScreenManager},

      { key: 'shortVideoPersonRelationManager', title: '关注管理', path: '/shortVideoPersonRelation', component: ShortVideoPersonRelationManager},

      { key: 'shortVideoMessageManager', title: '消息', path: '/shortVideoMessage', component: ShortVideoMessageManager},


      // 关联关系
      { key: 'SyncRelationPositionManager', title:'岗位关联关系配置', path: '/data/syncRelationPositionManager', component: SyncRelationPositionManager},
      { key: 'PositionChangeRecordManager', title:'配置变更信息', path: '/data/positionChangeRecordManager', component: PositionChangeRecordManager},
      { key: 'SyncTimsTransfer', title:'TMS数据迁移配置', path: '/data/syncTimsTransfer', component: SyncTimsTransfer},

      //同步邮件分类配置
      { key: 'SyncEmailConfigManager', title: '同步邮件分类配置', path: '/syncEmailConfigManager', component: SyncEmailConfigManager},

      // 水印
      { key : 'watermarkManager', title: '水印管理', path: '/watermark', component: WatermarkManager},
      { key: 'watermarkAdd', title: '新增水印', path: '/watermark/add', component: WatermarkDetail },
      { key: 'watermarkUpdate', title: '修改水印', path: '/watermark/update', component: WatermarkDetail },

      //邀请函模版
      { key: 'inviteLetterUpdate', title: '修改邀请函模版', path: '/biz/inviteLetter/update', component: InviteLetterEdit,cached: true  },
      { key: 'inviteLetterAdd', title: '新增邀请函模版', path: '/biz/inviteLetter/add', component: InviteLetterEdit,cached: true },
      { key: 'InviteLetterManager', title: '邀请函模版管理', path: '/biz/inviteLetter', component: InviteLetterManager },


     // 在线课程、班级、报名、考试、学习路径和作业，集成至1个菜单下
     // 站点管理员及区域管理员均需部署
    { key: 'LearningRecord', title: '学习记录', path: '/perm/programPerm/programList/learningRecord', component: LearningRecordManager },
    { key: 'ProgramDetail', title: '受众设置', path: '/perm/programPerm/programList/programAuth', component: ProgramAuth },
    { key: 'ProgramDetail', title: '新增课程', path: '/perm/programPerm/programList/programDetailAdd', component: ProgramDetail },
    { key: 'ProgramDetail', title: '编辑课程', path: '/perm/programPerm/programList/programDetailUpd', component: ProgramDetail, },
    { key: 'ProgramDetailShow', title: '查看关联课程', path: '/interact/activity/activityDetailToPart/activityPartLook/toProgram', component: ProgramDetailShow },
    { key: 'ProgramDetailShow', title: '查看课程', path: '/perm/programPerm/programList/programDetailShow', component: ProgramDetailShow },
    { key: 'ProgramEvaluation', title: '课程评价管理', path: '/perm/programPerm/programList/programEvaluation', component: ProgramEvaluation },
    { key: 'ProgramList', title: '课程管理', path: '/perm/programPerm/programList', component: ProgramList },
    //课件
    { key: 'ScheduleDetail', title: '新增课件', path: '/perm/programPerm/scheduleList/scheduleDetailAdd', component: ScheduleDetail },
    { key: 'ScheduleDetail', title: '编辑课件', path: '/perm/programPerm/scheduleList/scheduleDetailUpd', component: ScheduleDetail, },
    { key: 'ScheduleList', title: '课件管理', path: '/perm/programPerm/scheduleList', component: ScheduleList },
    //签到
    { key: 'SignInList', title: '签到详情', path: '/perm/classListPerm/classAideDetail/signInList', component: SignInList },
    //线下培训班级
    { key: 'surveyRecordInfo', title: '问卷收集记录', path: '/perm/classListPerm/classAideDetail/classStudentSurveyList/surveyRecordInfo', component: SurveyRecordInfo },
    { key: 'surveyRecordInfoDetail', title: '查看问卷详情', path: '/perm/classListPerm/classAideDetail/classStudentSurveyList/surveyRecordInfoDetail', component: SurveyRecordInfoDetail },
    { key: 'ClassStudentHomeworkList', title: '作业查看', path: '/perm/classListPerm/classAideDetail/classStudentHomeworkList', component: ClassStudentHomeworkList },
    { key: 'ClassStudentInteractLiveList', title: '参训记录', path: '/perm/classListPerm/classAideDetail/classStudentInteractLiveList', component: ClassStudentInteractLiveList },
    { key: 'ClassStudentInteractLiveList', title: '网络小课堂记录', path: '/perm/classListPerm/classAideDetail/classStudentNEVInteractLiveList', component: ClassStudentInteractLiveList },
    { key: 'ClassStudentInteractLiveList', title: '远程评估记录', path: '/perm/classListPerm/classAideDetail/classStudentRemoteEvaluationList', component: ClassStudentInteractLiveList },
    { key: 'ClassStudentRemoteAuthList', title: '远程认证管理', path: '/perm/classListPerm/classAideDetail/classStudentRemoteAuthList', component: ClassStudentRemoteAuthList },
    { key: 'ClassStudentNEVRemoteAuthList', title: 'NEV认证管理', path: '/perm/classListPerm/classAideDetail/classStudentNEVRemoteAuthList', component: ClassStudentNEVRemoteAuthList },
    { key: 'ClassStudentSurveyList', title: '满意度问卷记录', path: '/perm/classListPerm/classAideDetail/classStudentSurveyList', component: ClassStudentSurveyList },
    { key: 'ClassStudentExamList', title: '考试记录', path: '/perm/classListPerm/classAideDetail/classStudentExamList', component: ClassStudentExamList },
    { key: 'ClassStudentProgramList', title: '在线课程学习记录', path: '/perm/classListPerm/classAideDetail/classStudentProgramList', component: ClassStudentProgramList },
    { key: 'ClassStudentContentList', title: '资讯记录', path: '/perm/classListPerm/classAideDetail/classStudentContentList', component: ClassStudentContentList },
    { key: 'classResultFileImport', title: '班级学员成绩导入', path: '/perm/classListPerm/classResult/classResultFileImport', component: ClassResultFileImport },
    { key: 'LookClassInfo', title: '查看班级', path: '/perm/classListPerm/lookClassInfo', component: LookClassInfo },
    { key: 'ClassDetail', title: '新增班级', path: '/perm/classListPerm/classDetailAdd', component: ClassDetail },
    { key: 'ClassDetail', title: '新增班级', path: '/perm/classListPerm/classDetailCopy', component: ClassDetail },
    { key: 'ClassDetail', title: '编辑班级', path: '/perm/classListPerm/classDetailUpd', component: ClassDetail, },
    { key: 'ClassResult', title: '成绩管理', path: '/perm/classListPerm/classResult', component: ClassResult },
    { key: 'examinationRecord', title: '批阅考试', path: '/perm/classListPerm/classAideDetail/subjectiveReviewJump', component: ExaminationRecord },
    { key: 'homeworkRecordReviewList', title: '批阅作业', path: '/perm/classListPerm/classAideDetail/homeworkRecordReviewJump', component: HomeworkRecordReviewList },
    { key: 'ClassAideDetail', title: '课堂助手', path: '/perm/classListPerm/classAideDetail', component: ClassAideDetail },
    { key: 'ClassStudentList', title: '班级学员', path: '/perm/classListPerm/classStudentList', component: ClassStudentList },
    { key: 'ClassStudentList', title: '入店扫码记录', path: '/perm/classListPerm/classStudentQrList', component: ClassStudentQrList },
    { key: 'ClassStudentDetail', title: '班级学员查看', path: '/perm/classListPerm/classStudentDetail', component: ClassStudentDetail },
    { key: 'ClassList', title: '班级管理', path: '/perm/classListPerm', component: ClassList },
    { key: 'ClassAnnouncement', title: '班级公告', path: '/perm/classListPerm/announcement', component: ClassAnnouncement },
    { key: 'ClassAlbum', title: '班级相册', path: '/perm/classListPerm/album', component: ClassAlbum },
    { key: 'ClassComment', title: '班级评论', path: '/perm/classListPerm/comment', component: Comment },
    //报名相关
    { key: 'ClassResult', title: '成绩管理', path: '/perm/applyPerm/applyPlanClass/classResult', component: ClassResult },
    { key: 'studentGradesFileImport', title: '学员成绩导入', path: '/perm/applyPerm/applyPlanClass/importStudentGrades', component: StudentGradesFileImport },
    { key: 'applyPlan', title: '计划安排管理', path: '/perm/applyPerm/applyPlanNormal', component: ApplyPlanNormal },
    { key: 'applyPlan', title: '计划安排管理', path: '/perm/applyPerm/applyPlanClass', component: ApplyPlanClass },
    { key: 'applySurveyInfoInfoDetail', title: '查看问卷详情', path: '/perm/applyPerm/applyInfo/surveyRecordInfoDetail', component: SurveyRecordInfoDetail },
    { key: 'applyInfoTOPositionInfo', title: '查看任职', path: '/perm/applyPerm/applyInfo/lookPositionInfo', component: PersonInfoDetail },
    { key: 'applyRecordTOPositionInfo', title: '查看任职', path: '/perm/applyPerm/applyManager/lookPositionInfo', component: PersonInfoDetail },
    { key: 'applyManager', title: '报名记录管理', path: '/perm/applyPerm/applyManager', component: ApplyManager, },
    { key: 'permApplyStepsAdd', title: '新增报名', path: '/perm/applyPerm/applyDetailAdd', component: ApplySteps },
    { key: 'permApplyStepsEdit', title: '编辑报名', path: '/perm/applyPerm/applyDetailUpd', component: ApplySteps, },
    { key: 'applyInfo', title: '查看报名', path: '/perm/applyPerm/applyInfo', component: ApplyInfo },
    { key: 'applyInfoTOVerifyInfo', title: '报名详情查看', path: '/perm/applyPerm/applyManager/lookVerifyInfo', component: ApplyVerify },
    { key: 'applyVerify', title: '审核详情查看', path: '/perm/applyPermVerify/verify', component: ApplyVerify },
    { key: 'applyVerifyLookIden', title: '查看任职', path: '/perm/applyPermVerify/lookPositionInfo', component: PersonInfoDetail, },
    { key: 'applyVerifyList', title: '报名审核管理', path: '/perm/applyPermVerify', component: ApplyVerifyList, },
    { key: 'apply', title: '报名管理', path: '/perm/applyPerm', component: Apply },
    //考试相关
    { key: 'errorQuestionPersonInfoList', title: '错误人员情况', path: '/perm/examRecordPerm/errorQuestionInfo/errorQuestionAnalysis/errorQuestionPersonInfoList', component: ErrorQuestionPersonInfoList },
    { key: 'errorQuestionAnalysis', title: '错误分析', path: '/perm/examRecordPerm/errorQuestionInfo/errorQuestionAnalysis', component: ErrorQuestionAnalysisList },
    { key: 'errorQuestionInfoList', title: '错题率分析', path: '/perm/examRecordPerm/errorQuestionInfo', component: ErrorQuestionInfoList },
    //在线考核
    { key: 'examPersonAuthLook', title: '身份验证查看', path: '/perm/examRecordPerm/examPersonAuthLook', component: ExamPersonAuthDetail },
    { key: 'examPersonAuthAudit', title: '身份验证审核', path: '/perm/examRecordPerm/examPersonAuthAudit', component: ExamPersonAuthDetail },
    { key: 'examRecordAuthAudit', title: '身份验证审核', path: '/perm/examRecordPerm/examRecordAuthAudit', component: ExamPersonAuthDetail },
    { key: 'examPersonAuthManager', title: '身份验证记录', path: '/perm/examRecordPerm/examPersonAuth', component: ExamPersonAuthManager },
    { key: 'examRecordTOPositionInfo', title: '查看任职', path: '/perm/examRecordPerm/examRecordInfo/lookPositionInfo', component: PersonInfoDetail },
    { key: 'examGradeTOPositionInfo', title: '查看任职', path: '/perm/examRecordPerm/examGradeInfo/lookPositionInfo', component: PersonInfoDetail },
    { key: 'examRecordInfo', title: '考试记录查看', path: '/perm/examRecordPerm/examRecordInfo', component: ExamRecordInfo },
    { key: 'examGradeInfo', title: '成绩查看', path: '/perm/examRecordPerm/examGradeInfo', component: ExamGradeInfo },
    { key: 'examRecordTOLook', title: '考试预览', path: '/perm/examRecordPerm/examInfo', component: ExamInfo },
    { key: 'examRecord', title: '考试记录管理', path: '/perm/examRecordPerm', component: ExamRecordManager },
    //路径
    { key: 'trainPathFileImport', title: '培训路径导入', path: '/perm/trainPathPerm/trainPathFileImport', component: TrainPathFileImport },
    { key: 'trainPathDetail', title: '新增培训路径', path: '/perm/trainPathPerm/trainPathAdd', component: TrainPathDetail },
    { key: 'trainPathDetail', title: '编辑培训路径', path: '/perm/trainPathPerm/trainPathUpd', component: TrainPathDetail, },
    { key: 'trainPathStage', title: '路径阶段管理', path: '/perm/trainPathPerm/trainPathStage', component: TrainPathStage },
    { key: 'lookTrainPath', title: '查看', path: '/perm/trainPathPerm/lookTrainPath', component: LookTrainPath },
    { key: 'studentTrainPathList', title: '学员列表', path: '/perm/trainPathPerm/studentTrainPathList', component: StudentTrainPathList },
    { key: 'trainPathList', title: '培训路径管理', path: '/perm/trainPathPerm', component: TrainPathList },
    { key: 'trainPathSeriesContentList', title: '系列化课程内容管理', path: '/perm/trainPathPerm/seriesContentList', component: SeriesContentList },
    //路径成绩计算规则
    { key: 'trainPathStageScoreRule', title: '路径成绩规则', path: '/perm/trainPathStageScoreRulePerm', component: trainPathStageScoreRule },
    { key: 'trainPathStageScoreRuleDetail', title: '路径成绩规则新增', path: '/perm/trainPathStageScoreRulePerm/trainPathStageScoreRuleAdd', component: trainPathStageScoreRuleDetail },
    { key: 'trainPathStageScoreRuleDetail', title: '路径成绩规则编辑', path: '/perm/trainPathStageScoreRulePerm/trainPathStageScoreRuleUpd', component: trainPathStageScoreRuleDetail },
    //作业
    { key: 'homeworkRecordList', title: '作业记录', path: '/perm/homeworkListPerm/homeworkRecordList', component: HomeworkRecordList },
    { key: 'homeworkDetail', title: '编辑作业', path: '/perm/homeworkListPerm/homeworkUpd', component: HomeworkDetail, },
    { key: 'homeworkDetail', title: '新增作业', path: '/perm/homeworkListPerm/homeworkAdd', component: HomeworkDetail },
    { key: 'homeworkInfo', title: '查看作业', path: '/perm/homeworkListPerm/homeworkInfo', component: HomeworkInfo },
    { key: 'homeworkList', title: '作业管理', path: '/perm/homeworkListPerm', component: HomeworkList },



    { key: 'managerPermissionsSetting', title: '权限设置管理', path: '/org/managerPermissionsSetting', component: ManagerPermissionsSettingManager },
    //自动设置权限
    { key: 'permissionSettingManager', title: '自动赋权列表', path: '/permissionSetting/list', component: PermissionSettingManager },
    { key: 'PermissionSettingSave', title: '设置权限', path: '/permissionSetting/save', component: PermissionSettingAdd },



      {key: 'AccountConsolidationRecordManager', title: '账号合并管理', path: '/accountConsolidationRecord', component: AccountConsolidationRecordManager},
      {key: 'AccountConsolidationRecordDetail', title: '账号合并详情', path: '/accountConsolidationRecord/detail', component: AccountConsolidationRecordDetail},
      {key: 'AccountConsolidationRecordAdd', title: '合并账号', path: '/accountConsolidationRecord/add', component: AccountConsolidationRecordAdd},


      //标签管理
      { key: 'TypeAuth', title: '权限管理', path: '/biz/categoryType/labelMg/auth', component: TypeAuth },
      { key: 'LabelFeature', title: '标签推荐内容', path: '/biz/label/featureContent', component: LabelFeatureContent },
      { key: 'LabelUserImport', title: '标签用户导入', path: '/biz/label/labelUser/import', component: LabelUserImport },
      { key: 'LabelUserLook', title: '标签用户查看', path: '/biz/label/labelUser/look', component: LabelUserLook },
      { key: 'LabelUser', title: '标签用户', path: '/biz/label/labelUser', component: LabelUser },
      { key: 'LabelDetail', title: '标签基本信息', path: '/biz/label/update', component: LabelDetail },
      { key: 'LabelDetail', title: '标签基本信息', path: '/biz/label/add', component: LabelDetail },
      { key: 'LabelView', title: '查看标签', path: '/biz/label/look', component: LabelView },
      { key: 'LabelManager', title: '标签管理', path: '/biz/label', component: LabelManager },
      { key: 'QuestionTypeFileImportQuestion', title: '批量导入', path: '/biz/categoryType/labelMg/fileImport', component: QuestionTypeFileImport },
      { key: 'questionType', title: '标签分类管理', path: '/biz/categoryType/labelMg', component: QuestionType },



      //练习管理
      { key: 'PracticePaperInfo', title: '答题详情', path: '/online/practice/record/paper', component: PracticePaperInfo },
      { key: 'PracticeRecord', title: '练习记录', path: '/online/practice/record', component: PracticeRecord },
      { key: 'PracticeRankDate', title: '日排行', path: '/online/practice/rank/date', component: PracticeRankDate },
      { key: 'PracticeRankInfo', title: '练习排行', path: '/online/practice/rank', component: PracticeRankInfo },
      { key: 'PracticeView', title: '查看练习', path: '/online/practice/look', component: PracticeView },
      { key: 'PracticeDetail', title: '练习基本信息', path: '/online/practice/update', component: PracticeDetail },
      { key: 'PracticeDetail', title: '练习基本信息', path: '/online/practice/add', component: PracticeDetail },
      { key: 'PracticeManager', title: '练习管理', path: '/online/practice', component: PracticeManager },


      //404
      { key: '404', title: '页面没有找到', path: '', component: P404 }
    ]
  }


  //   path: '/login',
  //   title: '登录',
  //   component: Login,
  //   indexRoute: '/login',
  //   childRoutes: [
  //     // { key: 'login', title: '组织类型管理', path: '/login', component: Login }
  //   ]
  // }
  // {
  //   path: '/',
  //   title: '组件库',
  //   indexRoute: '/demo/test/dynamic',
  //   component: BasicLayout,
  //   childRoutes: [
  //     { key: 'dynamic', title: '动态模型', path: '/demo/test/dynamic', component: Dynamic },
  //     { key: 'recordLog', title: '日志', path: '/demo/test/recordLog', component: RecordLog },
  //     { key: 'template', title: '模版', path: '/demo/template', component: Template },
  //     { key: 'templateDemo', title: '布局模版', path: '/demo/templateDemo', component: TemplateDemo },
  //     // { key: 'tabListDemo', title: '列表组件', path: '/demo/test/tabListDemo', component: WizTabListDemo },
  //     { key: 'tableList', title: '表格列表', path: '/demo/test/tableList', component: TableList },
  //     { key: '403', title: '页面没有找到', path: '/demo/403', component: P403 },
  //     { key: '500', title: '页面没有找到', path: '/demo/500', component: P500 },
  //     { key: '404', title: '页面没有找到', path: '', component: P404 }
  //   ]
  // }
]

export default _routesConfig
